<template>
  <div class="home-container1">
    <section class="home-container2">
      <section class="home-hero">
        <video
          src="https://presentation-website-assets.teleporthq.io/templates/togthr/togthr-video.mp4"
          loop
          muted
          poster="/hero-bg.png"
          preload="auto"
          autoplay
          playsinline
          class="home-video"
          oncontextmenu="return false"
              style="-webkit-touch-callout:none"
        ></video>
        <div class="home-hero-content">
          <div class="home-header-container1">
            <div class="home-header11">
              <h1 class="home-heading10 Header1">
                <span class="home-text105">XR Interpersonal Solutions</span>
                <br class="home-text106" />
              </h1>
              <h1 class="home-heading11">
                <span class="home-text107">psychological and mental health</span>
                <br class="home-text108" />
              </h1>
            </div>
            <p class="home-caption10">
              <span class="home-text109">XR immersive therapy</span>
              <span>
                approach to psychological and mental health issues, using
                <span v-html="raw3500"></span>
              </span>
              <span class="home-text111">AI and Virtual Human technologies</span>
              <span>
                , that offers well-being &amp; life-long happiness solutions by
                life cycle
                <span v-html="raw5cp5"></span>
              </span>
            </p>
          </div>
          <button class="home-button1 button">
            <span>
              <span>Get started today</span>
              <br />
            </span>
          </button>
        </div>
      </section>
    </section>
    <section class="home-note">
      <h2 class="home-caption11">
        The most comprehensive lorem ipsum dolor sit amet, consectetur adipiscing
        elit, sed do eiusmod tempor incididunt ut labore et dolore magna.
      </h2>
    </section>
    <section class="home-statistics">
      <h2 class="home-heading12 Header1">Services</h2>
      <div class="home-content10">
        <div class="home-stat1">
          <h3 class="home-header12">
            <span class="home-text116">1</span>
            <br class="Caption_large" />
            <span class="Caption_large">EmpathyVR</span>
          </h3>
          <span class="home-caption12">
            Empathy Type and Empathy Expression Level<br/>Diagnostic Content for Teens
            <br/><br/>
            <span class="home-caption-product">2024 product</span>
            <span v-html="rawls3h"></span>
          </span>
        </div>
        <div class="home-stat2">
          <h3 class="home-header13">
            <span class="home-text119">2</span>

            <br class="Caption_large" />
            <span class="Caption_large">SITh</span>
          </h3>
          <span class="home-caption13">
            Innovative Psychotherapy Software & Immersive Content with Virtual Avatars
            <br/><br/>
            <span class="home-caption-product">2024 product</span>
          </span>
        </div>
        <div class="home-stat3">
          <h3 class="home-header14">
            <span class="home-text122">3</span>
            <br class="home-text123 Caption_large" />
            <span class="Caption_large">
              XR Therapists<br/>Training
            </span>
          </h3>
          <span class="home-caption14">
            Train XR therapists who can provide psychological counseling using XR
          </span>
        </div>
      </div>
    </section>
    <section class="home-slider1">
      <div class="home-header15">
        <h2 class="home-heading13">
          <span>The first all-in-one verse </span>
          <span class="home-text126">o</span>
          <span class="home-text127">
            ptimized for growth.
            <span v-html="rawsdhh"></span>
          </span>
        </h2>
      </div>
      <div class="home-selector">
        <p class="home-caption15">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
          tempor incididunt ut labore et dolore magna aliqua.
          <span v-html="raw7ukl"></span>
        </p>
        <div class="home-slide-titles">
          <div class="slide-title"><span>Metaverse</span></div>
          <div class="slide-title slide-title-active">
            <span>Ecosystems</span>
          </div>
          <div class="slide-title"><span>Development</span></div>
          <div class="slide-title"><span>Integration</span></div>
        </div>
      </div>
    </section>
    
    <section class="home-experience">
      <div class="home-images2">
        <div class="home-square2"></div>
        <img alt="image" src="/external/page1-01.png" class="home-image16"
        oncontextmenu="return false"
              style="-webkit-touch-callout:none"/>
      </div>
      <div class="home-content18">
        <div class="home-header23">
          <div class="home-header-container3">
            <div class="home-header24">
              <h2 class="home-heading20">
                <span><b>Difference with traditional methods</b></span>
              </h2>
            </div>
          </div>
          <div class="home-checkmarks">
            <div class="home-check1">
              <div class="home-mark1">
                <svg viewBox="0 0 1024 1024" class="home-icon23">
                  <path
                    d="M823.168 225.835l-439.168 439.168-183.168-183.168c-16.683-16.683-43.691-16.683-60.331 0s-16.683 43.691 0 60.331l213.333 213.333c16.683 16.683 43.691 16.683 60.331 0l469.333-469.333c16.683-16.683 16.683-43.691 0-60.331s-43.691-16.683-60.331 0z"
                  ></path>
                </svg>
              </div>
              <span class="home-text147">
                XR therapy techniques for psychological counseling and interpersonal solutions developed by psychological counselors and media researchers.
              </span>
            </div>
            <div class="home-check2">
              <div class="home-mark2">
                <svg viewBox="0 0 1024 1024" class="home-icon25">
                  <path
                    d="M823.168 225.835l-439.168 439.168-183.168-183.168c-16.683-16.683-43.691-16.683-60.331 0s-16.683 43.691 0 60.331l213.333 213.333c16.683 16.683 43.691 16.683 60.331 0l469.333-469.333c16.683-16.683 16.683-43.691 0-60.331s-43.691-16.683-60.331 0z"
                  ></path>
                </svg>
              </div>
              <span class="home-text148">Face-to-face counseling with the person you're struggling with, rather than relying on your imagination.</span>
            </div>
            <div class="home-check3">
              <div class="home-mark3">
                <svg viewBox="0 0 1024 1024" class="home-icon27">
                  <path
                    d="M823.168 225.835l-439.168 439.168-183.168-183.168c-16.683-16.683-43.691-16.683-60.331 0s-16.683 43.691 0 60.331l213.333 213.333c16.683 16.683 43.691 16.683 60.331 0l469.333-469.333c16.683-16.683 16.683-43.691 0-60.331s-43.691-16.683-60.331 0z"
                  ></path>
                </svg>
              </div>
              <span class="home-text149">
                Online consultation with a professional XR therapist.
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="home-get-started">
      <div class="home-header-container2">
        <div class="home-header20">
          <h2 class="home-heading18">
            <b>XR Therapists Training</b>
          </h2>
          <p class="home-caption24">
            Curriculum and certification process accredited by the Korea Association for Realistic Psychological Technology
          </p>
          <br/>
          <p class="home-caption24-2-title">
            Business to Business (B2B) Agreements
          </p>
          <div class="home-check1">
            <div class="home-mark1">
              <svg viewBox="0 0 1024 1024" class="home-icon23">
                <path
                  d="M823.168 225.835l-439.168 439.168-183.168-183.168c-16.683-16.683-43.691-16.683-60.331 0s-16.683 43.691 0 60.331l213.333 213.333c16.683 16.683 43.691 16.683 60.331 0l469.333-469.333c16.683-16.683 16.683-43.691 0-60.331s-43.691-16.683-60.331 0z"
                ></path>
              </svg>
            </div>
            <p class="home-caption24-2">
              Providing free training and content through agreements with the Gyeonggi Province Youth
              Counseling and Welfare Center
            </p>
          </div>
          <div class="home-check1">
            <div class="home-mark1">
              <svg viewBox="0 0 1024 1024" class="home-icon23">
                <path
                  d="M823.168 225.835l-439.168 439.168-183.168-183.168c-16.683-16.683-43.691-16.683-60.331 0s-16.683 43.691 0 60.331l213.333 213.333c16.683 16.683 43.691 16.683 60.331 0l469.333-469.333c16.683-16.683 16.683-43.691 0-60.331s-43.691-16.683-60.331 0z"
                ></path>
              </svg>
            </div>
            <p class="home-caption24-2">
              Collaboration with corporate communication training institutions
            </p>
          </div>
        </div>
      </div>
      <div class="image-group">
        <div class="image-group-row1">
          <img alt="image" src="/external/Group.png" class="home-image14-1"
          oncontextmenu="return false"
              style="-webkit-touch-callout:none"/> 
          <img alt="image" src="/external/Group-1.png" class="home-image14-2"
          oncontextmenu="return false"
              style="-webkit-touch-callout:none"/>  
        </div>
        <div class="image-group-row2">
          <img alt="image" src="/external/Group-2.png" class="home-image14-3"
          oncontextmenu="return false"
              style="-webkit-touch-callout:none"/>
        </div>     
      </div>
    </section>
    <section class="home-create">
      <div class="home-content20">
        <div class="home-header25">
          <h2 class="home-heading21">
            <span>
              Create your own
              <span v-html="rawwoyr"></span>
            </span>
            <span class="home-text154">environment</span>
            <span>now!</span>
            <br />
          </h2>
        </div>
        <button class="home-button4 button">
          <span>
            <span>Get started today</span>
            <br />
          </span>
        </button>
      </div>
    </section>
    <section class="home-comparision">
      <div class="home-header-container4">
        <div class="home-header26">
          <h2 class="home-heading22">
            <span>Environment c</span>
            <span class="home-text161">omparision</span>
            <br />
          </h2>
        </div>
        <p class="home-caption28">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod.
        </p>
      </div>
      <div class="home-table">
        <div class="home-row10">
          <div class="home-headers1">
            <span class="home-text163">Placeholder</span>
          </div>
          <div class="home-plans1">
            <div class="home-row11">
              <span class="home-text164">TOGHTR</span>
              <span class="home-text165">AGENCY</span>
              <span class="home-text166">FRELLANCE</span>
            </div>
          </div>
        </div>
        <div class="home-row12">
          <div class="home-headers2">
            <span class="home-text167">
              Duis aute irure dolor in reprehenderit
            </span>
          </div>
          <div class="home-plans2">
            <div class="home-row13">
              <div class="value"><app-check></app-check></div>
              <div class="value"><app-check></app-check></div>
              <div class="value"><app-check></app-check></div>
            </div>
          </div>
        </div>
        <div class="home-row14">
          <div class="home-headers3">
            <span class="home-text168">Lorem ipsum dolor sit amet</span>
          </div>
          <div class="home-plans3">
            <div class="home-row15">
              <div class="value"><app-check></app-check></div>
              <div class="value"><app-check></app-check></div>
              <div class="value"><app-line></app-line></div>
            </div>
          </div>
        </div>
        <div class="home-row16">
          <div class="home-headers4">
            <span class="home-text169">
              Duis aute irure dolor in reprehenderit
            </span>
          </div>
          <div class="home-plans4">
            <div class="home-row17">
              <div class="value"><span class="home-text170">Custom</span></div>
              <div class="value"><app-line></app-line></div>
              <div class="value"><app-line></app-line></div>
            </div>
          </div>
        </div>
        <div class="home-row18">
          <div class="home-headers5">
            <span class="home-text171">
              Duis aute irure dolor in reprehenderit
            </span>
          </div>
          <div class="home-plans5">
            <div class="home-row19">
              <div class="value"><span class="home-text172">Unlimited</span></div>
              <div class="value"><span class="home-text173">Limited</span></div>
              <div class="value"><app-line></app-line></div>
            </div>
          </div>
        </div>
        <div class="home-row20">
          <div class="home-headers6">
            <span class="home-text174">Lorem ipsum dolor sit amet</span>
          </div>
          <div class="home-plans6">
            <div class="home-row21">
              <div class="value"><app-check></app-check></div>
              <div class="value"><app-line></app-line></div>
              <div class="value"><span class="home-text175">Limited</span></div>
            </div>
          </div>
        </div>
        <div class="home-row22">
          <div class="home-headers7">
            <span class="home-text176">Lorem ipsum dolor sit amet</span>
          </div>
          <div class="home-plans7">
            <div class="home-row23">
              <div class="value"><app-check></app-check></div>
              <div class="value"><app-check></app-check></div>
              <div class="value"><app-check></app-check></div>
            </div>
          </div>
        </div>
        <div class="home-row24">
          <div class="home-headers8">
            <span class="home-text177">Lorem ipsum dolor sit amet</span>
          </div>
          <div class="home-plans8">
            <div class="home-row25">
              <div class="value"><app-check></app-check></div>
              <div class="value"><span class="home-text178">Limited</span></div>
              <div class="value"><app-line></app-line></div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="home-data">
      <div class="home-header-container5">
        <div class="home-header27">
          <div class="home-row26">
            <h2 class="home-heading23">
              <span>
                Understand your data to manage all in one
                <span v-html="rawfpur"></span>
              </span>
              <span class="home-text180">platform</span>
              <br />
            </h2>
          </div>
        </div>
        <p class="home-caption29">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
          tempor incididunt ut labore et dolore magna aliqua.
          <span v-html="rawlgmg"></span>
        </p>
      </div>
      <div class="home-content21">
        <div class="home-image17">
          <img alt="image" src="/data-1400w.png" class="home-image18"
          oncontextmenu="return false"
              style="-webkit-touch-callout:none"/>
        </div>
        <div class="home-accordion">
          <div data-role="accordion-container" class="accordion">
            <div>
              <h3 class="home-header28">Management</h3>
              <p data-role="accordion-content" class="accordion-content">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem
                ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                tempor incididunt ut labore et dolore magna aliqua.
                <span v-html="rawysti"></span>
              </p>
            </div>
            <icon-container
              rootClassName="icon-containerroot-class-name"
            ></icon-container>
          </div>
          <div data-role="accordion-container" class="accordion">
            <div>
              <h3 class="home-header29">Integrations</h3>
              <p data-role="accordion-content" class="accordion-content">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem
                ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                tempor incididunt ut labore et dolore magna aliqua.
                <span v-html="raw55pj"></span>
              </p>
            </div>
            <icon-container
              rootClassName="icon-containerroot-class-name1"
            ></icon-container>
          </div>
          <div data-role="accordion-container" class="accordion">
            <div>
              <h3 class="home-header30">Customer Solutions</h3>
              <p data-role="accordion-content" class="accordion-content">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem
                ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                tempor incididunt ut labore et dolore magna aliqua.
                <span v-html="raw1o2i"></span>
              </p>
            </div>
            <icon-container
              rootClassName="icon-containerroot-class-name2"
            ></icon-container>
          </div>
          <div data-role="accordion-container" class="accordion">
            <div>
              <h3 class="home-header31">Recruiting</h3>
              <p data-role="accordion-content" class="accordion-content">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem
                ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                tempor incididunt ut labore et dolore magna aliqua.
                <span v-html="rawy3nh"></span>
              </p>
            </div>
            <icon-container
              rootClassName="icon-containerroot-class-name3"
            ></icon-container>
          </div>
          <div>
            <div class="home-container6">
              <!-- <DangerousHTML
                html="<script>
   /*
    Accordion - Code Embed
    */
    const accordionContainers = document.querySelectorAll('[data-role='accordion-container']'); // All accordion containers
    const accordionContents = document.querySelectorAll('[data-role='accordion-content']'); // All accordion content
    const accordionIconsClosed = document.querySelectorAll('[data-role='accordion-icon-closed']'); // All accordion closed icons
    const accordionIconsOpen = document.querySelectorAll('[data-role='accordion-icon-open']'); // All accordion open icons
  
    accordionContents.forEach((accordionContent) => {
        accordionContent.style.display = 'none'; //Hides all accordion contents
    });
  
    accordionIconsClosed.forEach((icon) => {
      icon.style.display = 'flex'
    })
  
    accordionIconsOpen.forEach((icon) => {
      icon.style.display = 'none'
    })
  
    accordionContainers.forEach((accordionContainer, index) => {
        accordionContainer.addEventListener('click', () => {
            if (accordionContents[index].style.display === 'flex') {
                // If the accordion is already open, close it
                accordionContents[index].style.display = 'none';
                accordionIconsClosed[index].style.display = 'flex';
                accordionIconsOpen[index].style.display = 'none'
            } else {
                // If the accordion is closed, open it
                accordionContents.forEach((accordionContent) => {
                    accordionContent.style.display = 'none'; //Hides all accordion contents
                });
  
                accordionIconsClosed.forEach((accordionIcon) => {
                    accordionIcon.style.display = 'flex'; // Resets all icon transforms to 0deg (default)
                });
  
                accordionIconsOpen.forEach((accordionIcon) => {
                  accordionIcon.style.display = 'none';
                })
                
                accordionContents[index].style.display = 'flex'; // Shows accordion content
                accordionIconsClosed[index].style.display = 'none'; // Rotates accordion icon 180deg
                accordionIconsOpen[index].style.display = 'flex';
            }
        });
    });
  </script>
  "
              ></DangerousHTML> -->
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="home-customer">
      <div class="home-header32">
        <h2 class="home-heading24">
          <span>
            Customer validation is an essential phase of the
            <span v-html="rawkffn"></span>
          </span>
          <span class="home-text183">product development process</span>
          <br />
        </h2>
      </div>
      <div class="home-quotes">
        <div class="home-quote1">
          <p class="home-quote2">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem
            ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
            tempor incididunt ut labore et dolore magna aliqua.
            <span v-html="rawccp3"></span>
          </p>
          <div class="home-author3">
            <span class="home-name3">Joanna Smith</span>
            <span class="home-location1">Briville</span>
          </div>
        </div>
        <div class="home-quote3">
          <p class="home-quote4">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem
            ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
            tempor incididunt ut labore et dolore magna aliqua.
            <span v-html="rawt07r"></span>
          </p>
          <div class="home-author4">
            <span class="home-name4">Joanna Smith</span>
            <span class="home-location2">Briville</span>
          </div>
        </div>
        <div class="home-quote5">
          <p class="home-quote6">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem
            ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
            tempor incididunt ut labore et dolore magna aliqua.
            <span v-html="rawjqcm"></span>
          </p>
          <div class="home-author5">
            <span class="home-name5">Joanna Smith</span>
            <span class="home-location3">Briville</span>
          </div>
        </div>
        <div class="home-quote7">
          <p class="home-quote8">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem
            ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
            tempor incididunt ut labore et dolore magna aliqua.
            <span v-html="raw6x8e"></span>
          </p>
          <div class="home-author6">
            <span class="home-name6">Joanna Smith</span>
            <span class="home-location4">Briville</span>
          </div>
        </div>
      </div>
      <div class="home-controls2">
        <button class="home-previous2 button">
          <svg viewBox="0 0 1024 1024" class="home-icon32">
            <path
              d="M542.165 780.501l-225.835-225.835h494.336c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-494.336l225.835-225.835c16.683-16.683 16.683-43.691 0-60.331s-43.691-16.683-60.331 0l-298.667 298.667c-4.096 4.096-7.168 8.789-9.259 13.824-2.176 5.205-3.243 10.795-3.243 16.341 0 10.923 4.181 21.845 12.501 30.165l298.667 298.667c16.683 16.683 43.691 16.683 60.331 0s16.683-43.691 0-60.331z"
            ></path>
          </svg>
        </button>
        <button class="home-next2 button">
          <svg viewBox="0 0 1024 1024" class="home-icon34">
            <path
              d="M481.835 243.499l225.835 225.835h-494.336c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667h494.336l-225.835 225.835c-16.683 16.683-16.683 43.691 0 60.331s43.691 16.683 60.331 0l298.667-298.667c3.925-3.925 7.083-8.619 9.259-13.824 4.309-10.453 4.309-22.229 0-32.683-2.091-5.035-5.163-9.728-9.259-13.824l-298.667-298.667c-16.683-16.683-43.691-16.683-60.331 0s-16.683 43.691 0 60.331z"
            ></path>
          </svg>
        </button>
        <button class="button home-button5">
          <span>
            <span>View all cases</span>
            <br />
          </span>
        </button>
      </div>
    </section>
    <section class="home-about-vhex">
      <div class="home-content30">
        <div class="home-column1">
          <div class="home-element5">
            <h2 class="home-heading25 SemiHeader1">
              <span>About VHEX</span>
              <span class="home-text189"><span v-html="rawo7lp"></span></span>
            </h2>
            <h3 class="home-header33">
              <span>
                The greatest technology is the one you can&apos;t see or feel.
              </span>
              <br />
              <span>
                Our technology allows us to look at each other and feel our
                hearts.
              </span>
            </h3>
            <span class="home-text193">
              <span>Founded in January 2023, VHEX Lab is a company
                    that develops and provides psychological tests,
                    psychological counseling and psychotherapy
                    based on XR-AI-VH technology. In 2024 we will
                    launch and provide services for empathy type
                    diagnosis with “EmpathyVR” and for psychotherapy
                    using the Gestalt psychological techniques with
                    “SITh (Self-Insight Therapy)”. We are also running XR
                    technology training programs psychologists and the
                    general public for life coaching using XR.
              </span>
            </span>
          </div>
          <img
            alt="image"
            src="/clip%20path%20group%20(1)-800h.png"
            class="home-image19"
            oncontextmenu="return false"
              style="-webkit-touch-callout:none"
          />
        </div>
      </div>
    </section>
    <footer class="home-footer">
      <div class="home-content31">
        <div class="home-main">
          <div class="home-branding">
            <img
              alt="image"
              src="/artboard%201%20copy-200h.png"
              class="home-image20"
              oncontextmenu="return false"
              style="-webkit-touch-callout:none"
            />
            <div class="home-container7">
              <div class="home-frame1">
                <svg viewBox="0 0 1024 1024" class="home-icon36">
                  <path
                    d="M938.667 426.667c0-117.803-47.787-224.555-124.971-301.696s-183.893-124.971-301.696-124.971-224.555 47.787-301.696 124.971-124.971 183.893-124.971 301.696c0 24.277 2.261 48.128 6.4 71.509 11.691 66.048 38.357 128.171 71.765 184.32 116.565 195.883 324.821 334.336 324.821 334.336 14.123 9.259 32.64 9.771 47.317 0 0 0 208.299-138.453 324.821-334.336 33.408-56.149 60.075-118.272 71.765-184.32 4.181-23.381 6.443-47.232 6.443-71.509zM853.333 426.667c0 18.944-1.749 37.845-5.077 56.661-9.429 53.333-31.445 105.728-61.099 155.563-83.285 139.947-220.416 249.643-275.157 290.091-54.784-40.448-191.872-150.144-275.157-290.091-29.653-49.835-51.669-102.229-61.099-155.563-3.328-18.816-5.077-37.717-5.077-56.661 0-94.251 38.144-179.541 99.968-241.365s147.115-99.968 241.365-99.968 179.541 38.144 241.365 99.968 99.968 147.115 99.968 241.365zM682.667 426.667c0-47.104-19.157-89.856-50.005-120.661s-73.557-50.005-120.661-50.005-89.856 19.157-120.661 50.005-50.005 73.557-50.005 120.661 19.157 89.856 50.005 120.661 73.557 50.005 120.661 50.005 89.856-19.157 120.661-50.005 50.005-73.557 50.005-120.661zM597.333 426.667c0 23.595-9.515 44.843-25.003 60.331s-36.736 25.003-60.331 25.003-44.843-9.515-60.331-25.003-25.003-36.736-25.003-60.331 9.515-44.843 25.003-60.331 36.736-25.003 60.331-25.003 44.843 9.515 60.331 25.003 25.003 36.736 25.003 60.331z"
                  ></path>
                </svg>
                <span class="home-text201 Caption1">
                  <span>Gwanggyo Business Center,Room 603/604,</span>
                  <br />
                  <span>
                    Gwanggyo-ro 156, Suwon-si, Gyeonggi-do 16506
                    <span v-html="rawdqbo"></span>
                  </span>
                  <span>(South Korea)</span>
                  <span class="home-text206"><span v-html="rawd1nf"></span></span>
                </span>
              </div>
              <div class="home-frame2">
                <svg viewBox="0 0 1024 1024" class="home-icon38">
                  <path
                    d="M633.984 255.189c40.235 7.851 74.24 29.141 98.56 58.624 17.92 21.76 30.592 47.957 36.352 76.501 4.651 23.083 27.179 38.016 50.261 33.365s38.016-27.179 33.365-50.261c-8.533-42.325-27.349-81.365-54.144-113.877-36.437-44.203-87.765-76.331-148.053-88.064-23.125-4.523-45.525 10.581-50.048 33.707s10.581 45.525 33.707 50.048zM637.44 85.077c85.333 9.472 159.701 49.579 213.547 108.544 47.701 52.224 79.275 119.211 87.979 192.811 2.773 23.381 23.979 40.149 47.36 37.376s40.149-23.979 37.376-47.36c-10.795-91.605-50.176-175.189-109.696-240.384-67.328-73.728-160.512-123.989-267.136-135.808-23.424-2.603-44.501 14.293-47.104 37.675s14.293 44.501 37.675 47.104zM981.333 721.92c0.683-30.464-10.069-59.904-28.715-82.901-19.627-24.149-48.171-41.259-82.133-46.080-34.133-4.181-72.32-13.397-110.336-27.563-18.475-6.784-38.101-9.301-57.344-7.424-28.288 2.731-55.765 14.891-77.611 36.48l-30.72 30.72c-75.52-47.659-143.36-113.792-195.541-195.797l30.976-30.976c13.739-14.080 24.021-30.976 30.165-49.323 9.045-26.965 9.131-57.003-1.664-85.803-12.331-32.128-22.101-70.144-27.477-110.72-4.437-30.507-19.413-57.472-41.088-77.013-22.997-20.693-53.589-33.195-86.485-32.853h-127.829c-3.755 0-7.765 0.171-11.648 0.512-35.157 3.2-65.792 20.395-86.741 45.483s-32.341 58.325-29.141 93.824c12.8 131.243 58.24 266.368 137.216 388.352 64.085 102.955 155.648 197.248 268.715 269.056 109.568 72.405 242.517 122.112 387.669 137.856 3.925 0.384 8.149 0.555 12.288 0.555 35.328-0.128 67.328-14.635 90.368-37.845s37.248-55.339 37.12-90.496zM896 721.92v128c0.043 11.947-4.651 22.613-12.373 30.379s-18.304 12.587-30.123 12.629l-3.755-0.171c-130.56-14.208-250.581-59.221-348.757-124.117-103.595-65.835-185.984-150.955-243.285-242.944-72.405-111.787-113.28-233.856-124.757-351.488-1.024-11.435 2.731-22.443 9.771-30.891s17.195-14.080 28.928-15.147l131.712-0.171c11.563-0.128 21.632 4.011 29.312 10.923 7.253 6.571 12.288 15.616 13.781 25.941 6.059 45.739 17.408 90.325 32.299 129.067 3.456 9.216 3.413 19.072 0.427 28.075-2.091 6.187-5.589 11.989-10.325 16.853l-53.845 53.803c-13.824 13.824-16.171 34.731-6.912 51.243 67.584 118.827 163.797 211.499 272.256 272.128 16.939 9.472 37.632 6.144 50.987-7.083l54.187-54.187c7.083-6.997 16.085-10.965 25.515-11.904 6.485-0.64 13.227 0.213 19.584 2.56 43.605 16.256 88.32 27.136 129.451 32.171 10.283 1.451 19.712 7.083 26.24 15.147 6.272 7.723 9.856 17.579 9.643 29.099z"
                  ></path>
                </svg>
                <span class="home-text207 Caption1">
                  <span>031-212-2107 / Fax 031-212-2109</span>
                </span>
              </div>
              <div class="home-frame3">
                <svg viewBox="0 0 1024 1024" class="home-icon40">
                  <path
                    d="M128 337.963l359.552 251.691c14.507 10.027 33.92 10.496 48.939 0l359.509-251.691v430.037c0 11.605-4.693 22.229-12.587 30.080s-18.475 12.587-30.080 12.587h-682.667c-11.605 0-22.229-4.693-30.080-12.587s-12.587-18.475-12.587-30.080zM42.667 256.512v511.488c0 35.328 14.507 67.371 37.547 90.453s55.125 37.547 90.453 37.547h682.667c35.328 0 67.371-14.507 90.453-37.547s37.547-55.125 37.547-90.453v-511.488c0-0.427 0-0.853 0-1.28-0.213-35.029-14.635-66.773-37.547-89.685-23.083-23.040-55.125-37.547-90.453-37.547h-682.667c-35.328 0-67.371 14.507-90.453 37.547-22.912 22.912-37.333 54.656-37.547 89.728 0 0.213 0 0.469 0 0.725zM891.477 236.971l-379.477 265.6-379.477-265.6c2.048-4.096 4.779-7.808 8.021-11.051 7.893-7.893 18.517-12.587 30.123-12.587h682.667c11.605 0 22.229 4.693 30.080 12.587 3.243 3.243 5.973 6.997 8.021 11.051z"
                  ></path>
                </svg>
                <span class="home-text209 Caption1">
                  <span>vhexlab@vhexlab.co.kr</span>
                </span>
              </div>
            </div>
          </div>
          <div class="home-links">
            <div class="home-column2">
              <span class="home-header34">Company</span>
              <div class="home-list1">
                <router-link to="/" class="home-navlink10">About</router-link>
                <router-link to="/" class="home-navlink11">Services</router-link>
                <router-link to="/" class="home-navlink12">How</router-link>
                <router-link to="/" class="home-navlink13">
                  <span class="home-text211">Why</span>
                  <br />
                </router-link>
              </div>
            </div>
            <div class="home-column3">
              <span class="home-header35">Extern</span>
              <div class="home-list2">
                <router-link to="/" class="home-navlink14">News</router-link>
                <router-link to="/" class="home-navlink15">Articles</router-link>
                <router-link to="/" class="home-navlink16">Blog</router-link>
                <router-link to="/" class="home-navlink17">Privacy</router-link>
                <router-link to="/" class="home-navlink18">Terms</router-link>
                <router-link to="/" class="home-navlink19">Legal</router-link>
                <router-link to="/" class="home-navlink20">Press</router-link>
              </div>
            </div>
            <div class="home-column4">
              <span class="home-header36">Social</span>
              <div class="home-list3">
                <router-link to="/" class="home-navlink21">LinkedIn</router-link>
                <router-link to="/" class="home-navlink22">Twitter</router-link>
                <router-link to="/" class="home-navlink23">Instagram</router-link>
                <router-link to="/" class="home-navlink24">Facebook</router-link>
                <router-link to="/" class="home-navlink25">TikTok</router-link>
              </div>
            </div>
            <!-- <button data-role="scroll-top" class="home-button6 button">
              <img alt="image" src="/arrow.svg" class="home-image21" />
            </button> -->
          </div>
        </div>
        <div class="home-bottom">
          <span class="home-text213">© 2024 vhexlab - All rights reserved</span>
        </div>
      </div>
    </footer>
    <div>
      <div class="home-container9">
        <!-- <DangerousHTML
          html="<script>
  document.addEventListener('DOMContentLoaded', function() {
    // get the element with the 'scroll-top' data-role
    const scrollTopBtn = document.querySelector('[data-role='scroll-top']');
  
    // when the element is clicked
    scrollTopBtn.addEventListener('click', function() {
      // smoothly scroll to the top of the page
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  });
  </script>
  "
        ></DangerousHTML> -->
      </div>
    </div>
  </div>
</template>

<script>
import DangerousHTML from 'dangerous-html/vue'
import AppCheck from '../components/check'
import AppLine from '../components/line'
import IconContainer from '../components/icon-container'

export default {
  name: 'Home',
  props: {},
  components: {
    DangerousHTML,
    AppCheck,
    AppLine,
    IconContainer,
  },
  data() {
    return {
      raw3500: ' ',
      raw5cp5: ' ',
      rawls3h: ' ',
      rawsdhh: ' ',
      raw7ukl: ' ',
      raw1k9u: ' ',
      rawifbg: ' ',
      rawnksv: ' ',
      rawf4lv: ' ',
      raw2x97: ' ',
      rawgw4r: ' ',
      rawfpm0: ' ',
      rawr6mp: ' ',
      raw2ss9: ' ',
      raw5mor: ' ',
      raw2tfb: ' ',
      rawwoyr: ' ',
      rawfpur: ' ',
      rawlgmg: ' ',
      rawysti: ' ',
      raw55pj: ' ',
      raw1o2i: ' ',
      rawy3nh: ' ',
      rawkffn: ' ',
      rawccp3: ' ',
      rawt07r: ' ',
      rawjqcm: ' ',
      raw6x8e: ' ',
      rawo7lp: ' ',
      rawdqbo: ' ',
      rawd1nf: ' ',
    }
  },
  metaInfo: {
    title: 'VHEX Lab',
    meta: [
      {
        property: 'og:title',
        content: 'VHEX Lab',
      },
    ],
  },
}
</script>

<style scoped>
.home-container1 {
  width: 100%;
  display: flex;
  overflow: hidden;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
  background-color: #0e0f1e;
}
.home-container2 {
  flex: 0 0 auto;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.home-hero {
  width: 100%;
  height: 100vh;
  display: flex;
  position: relative;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
}
.home-video {
  top: 0px;
  left: 0px;
  width: 100%;
  filter: opacity(0.6);
  height: 1200px;
  position: absolute;
  align-self: center;
  object-fit: cover;
}

.home-fragment1 {
  display: contents;
}
.home-text100 {
  display: inline-block;
}
.home-fragment2 {
  display: contents;
}
.home-text101 {
  color: rgb(255, 255, 255);
  display: inline-block;
}
.home-fragment3 {
  display: contents;
}
.home-text102 {
  color: #ffffff;
  display: inline-block;
}
.home-fragment4 {
  display: contents;
}
.home-text103 {
  display: inline-block;
}
.home-fragment5 {
  display: contents;
}
.home-text104 {
  display: inline-block;
}
.home-hero-content {
  gap: var(--dl-space-space-fiveunits);
  flex: 1;
  width: 1195px;
  display: flex;
  z-index: 100;
  max-width: var(--dl-size-size-maxwidth);
  align-items: flex-start;
  padding-top: 250px;
  padding-left: var(--dl-space-space-threeunits);
  flex-direction: column;
  justify-content: flex-start;
}
.home-header-container1 {
  gap: var(--dl-space-space-oneandhalfunits);
  display: flex;
  align-items: flex-start;
  margin-left: 20px;
  flex-direction: column;
  justify-content: center;
}
.home-header11 {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.home-heading10 {
  color: rgb(255, 255, 255);
  width: 1179px;
  max-width: auto;
}
.home-text105 {
  font-size: 88px;
}
.home-text106 {
  font-size: 100px;
}
.home-heading11 {
  color: rgb(255, 255, 255);
  width: 1178px;
  font-size: 100px;
  max-width: auto;
  font-weight: 500;
}
.home-text107 {
  font-size: 55px;
  font-style: italic;
  font-family: "Playfair Display";
}
.home-text108 {
  font-style: normal;
}
.home-caption10 {
  color: rgb(255, 255, 255);
  width: 877px;
  font-size: 24px;
  line-height: 36px;
}
.home-text109 {
  color: var(--dl-color-main-orange-01);
}
.home-text111 {
  color: var(--dl-color-main-orange-01);
}
.home-button1 {
  display: none;
  background-color: var(--dl-color-main-navy-01);
}
.home-note {
  width: 100%;
  display: none;
  max-width: var(--dl-size-size-maxwidth);
  align-items: flex-end;
  padding-top: 120px;
  padding-left: var(--dl-space-space-fiveunits);
  padding-right: var(--dl-space-space-fiveunits);
  flex-direction: column;
  padding-bottom: 120px;
  justify-content: flex-start;
}
.home-caption11 {
  color: #7C7C80;
  font-size: 40px;
  max-width: 800px;
  font-style: normal;
  font-weight: 400;
  line-height: 52px;
  margin-right: 158px;
}
.home-statistics {
  width: 100%;
  display: flex;
  max-width: var(--dl-size-size-maxwidth);
  align-items: center;
  padding-top: var(--dl-space-space-fiveunits);
  padding-left: var(--dl-space-space-fiveunits);
  padding-right: var(--dl-space-space-fiveunits);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-fiveunits);
  justify-content: center;
}
.home-heading12 {
  color: var(--dl-color-main-orange-01);
  width: 1169px;
  align-self: center;
  margin-top: var(--dl-space-space-oneandhalfunits);
  text-align: center;
}
.home-content10 {
  width: 1746px;
  display: flex;
  align-items: flex-start;
  padding-top: var(--dl-space-space-fiveunits);
  border-color: #313133;
  flex-direction: row;
  justify-content: flex-start;
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.home-stat1 {
  gap: var(--dl-space-space-oneandhalfunits);
  width: 658px;
  display: flex;
  align-items: center;
  border-color: #313133;
  flex-direction: column;
  padding-bottom: var(--dl-space-space-fiveunits);
  justify-content: center;
  border-right-width: 1px;
}
.home-header12 {
  color: rgb(255, 255, 255);
  font-size: 50px;
  text-align: center;
  font-family: "Open Sans";
  font-weight: 600;
  line-height: 1.15;
  text-transform: none;
  text-decoration: none;
}
.home-text116 {
  color: var(--dl-color-main-navy-01);
  font-size: 70px;
  font-weight: 800;
}
.home-caption12 {
  color: rgb(124, 124, 128);
  text-align:center;
  width:440px;
}
.home-caption-product{
  color: rgb(87, 87, 93);
}
.home-stat2 {
  gap: var(--dl-space-space-oneandhalfunits);
  width: 736px;
  display: flex;
  align-items: center;
  border-color: #313133;
  flex-direction: column;
  padding-bottom: var(--dl-space-space-fiveunits);
  justify-content: center;
  border-right-width: 1px;
}
.home-header13 {
  color: rgb(255, 255, 255);
  font-size: 50px;
  text-align: center;
  font-family: "Open Sans";
  font-weight: 600;
  line-height: 1.15;
  text-transform: none;
  text-decoration: none;
}
.home-text119 {
  color: var(--dl-color-main-navy-01);
  font-size: 70px;
  font-weight: 800;
}
.home-caption13 {
  color: rgb(124, 124, 128);
  text-align:center;
  width:400px;
}
.home-stat3 {
  gap: var(--dl-space-space-oneandhalfunits);
  flex: 1;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-bottom: var(--dl-space-space-fiveunits);
  justify-content: center;
}
.home-header14 {
  color: rgb(255, 255, 255);
  width: 567px;
  font-size: 50px;
  text-align: center;
  font-family: "Open Sans";
  font-weight: 600;
  line-height: 1.15;
  text-transform: none;
  text-decoration: none;
}
.home-text122 {
  color: var(--dl-color-main-navy-01);
  font-size: 70px;
  font-weight: 800;
}
.home-text123 {
  font-size: 70px;
  font-family: "Open Sans";
  font-weight: 800;
  line-height: 1.15;
  text-transform: none;
  text-decoration: none;
}
.home-caption14 {
  color: rgb(124, 124, 128);
  text-align: center;
}
.home-slider1 {
  gap: var(--dl-space-space-oneandhalfunits);
  width: 100%;
  display: none;
  position: relative;
  max-width: var(--dl-size-size-maxwidth);
  align-items: flex-start;
  padding-top: var(--dl-space-space-fiveunits);
  padding-left: var(--dl-space-space-fiveunits);
  padding-right: var(--dl-space-space-fiveunits);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-fiveunits);
  justify-content: flex-start;
}
.home-header15 {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.home-heading13 {
  color: rgb(255, 255, 255);
  font-size: 60px;
  max-width: 900px;
  font-style: normal;
  font-weight: 400;
}
.home-text126 {
  font-style: italic;
  font-family: "Playfair Display";
  font-weight: 500;
}
.home-text127 {
  font-style: italic;
  font-family: "Playfair Display";
  font-weight: 500;
}
.home-selector {
  width: 100%;
  display: flex;
  align-items: flex-end;
  flex-direction: row;
  justify-content: space-between;
}
.home-caption15 {
  color: rgb(124, 124, 128);
  font-size: 24px;
  max-width: 600px;
  line-height: 36px;
}
.home-slide-titles {
  gap: var(--dl-space-space-threeunits);
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}
.home-slides {
  gap: var(--dl-space-space-fourunits);
  display: none;
  overflow: hidden;
  position: relative;
  align-items: flex-start;
  flex-direction: column;
  padding-bottom: var(--dl-space-space-fiveunits);
}
.home-slider2 {
  gap: var(--dl-space-space-fiveunits);
  display: flex;
  align-items: center;
  flex-direction: row;
}
.home-slider-container {
  gap: var(--dl-space-space-fourunits);
  display: flex;
  align-items: center;
  flex-direction: column;
}
.home-slider-track-container {
  display: flex;
  align-items: center;
  flex-direction: row;
}
.home-slider-track {
  display: flex;
  align-items: center;
  flex-direction: row;
}
.home-image10 {
  height: 400px;
  object-fit: cover;
  aspect-ratio: 1;
}
.home-content11 {
  height: 400px;
  display: flex;
  align-items: flex-start;
  padding-top: var(--dl-space-space-fiveunits);
  padding-left: var(--dl-space-space-threeunits);
  padding-right: var(--dl-space-space-threeunits);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-threeunits);
  justify-content: space-between;
}
.home-header16 {
  gap: var(--dl-space-space-threeunits);
  display: flex;
  flex-direction: column;
}
.home-heading14 {
  color: rgb(255, 255, 255);
  font-size: 40px;
  font-style: normal;
  font-weight: 500;
}
.home-caption16 {
  color: rgb(204, 204, 255);
  max-width: 600px;
  line-height: 24px;
}
.home-more1 {
  gap: 4px;
  cursor: pointer;
  display: flex;
  transition: 0.3s;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}
.home-more1:hover {
  opacity: 0.5;
}
.home-caption17 {
  color: rgb(255, 255, 255);
  max-width: 600px;
  font-style: normal;
  font-weight: 500;
}
.home-icon10 {
  fill: #ffffff;
  width: 14px;
  height: 14px;
}
.home-image11 {
  object-fit: cover;
  aspect-ratio: 1;
}
.home-content12 {
  height: 400px;
  display: flex;
  align-items: flex-start;
  padding-top: var(--dl-space-space-fiveunits);
  padding-left: var(--dl-space-space-threeunits);
  padding-right: var(--dl-space-space-threeunits);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-threeunits);
  justify-content: space-between;
}
.home-header17 {
  gap: var(--dl-space-space-threeunits);
  display: flex;
  flex-direction: column;
}
.home-heading15 {
  color: rgb(255, 255, 255);
  font-size: 40px;
  font-style: normal;
  font-weight: 500;
}
.home-caption18 {
  color: rgb(204, 204, 255);
  max-width: 600px;
  line-height: 24px;
}
.home-more2 {
  gap: 4px;
  cursor: pointer;
  display: flex;
  transition: 0.3s;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}
.home-more2:hover {
  opacity: 0.5;
}
.home-caption19 {
  color: rgb(255, 255, 255);
  max-width: 600px;
  font-style: normal;
  font-weight: 500;
}
.home-icon12 {
  fill: #ffffff;
  width: 14px;
  height: 14px;
}
.home-image12 {
  height: 400px;
  object-fit: cover;
  aspect-ratio: 1;
}
.home-content13 {
  height: 400px;
  display: flex;
  align-items: flex-start;
  padding-top: var(--dl-space-space-fiveunits);
  padding-left: var(--dl-space-space-threeunits);
  padding-right: var(--dl-space-space-threeunits);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-threeunits);
  justify-content: space-between;
}
.home-header18 {
  gap: var(--dl-space-space-threeunits);
  display: flex;
  flex-direction: column;
}
.home-heading16 {
  color: rgb(255, 255, 255);
  font-size: 40px;
  font-style: normal;
  font-weight: 500;
}
.home-caption20 {
  color: rgb(204, 204, 255);
  max-width: 600px;
  line-height: 24px;
}
.home-more3 {
  gap: 4px;
  cursor: pointer;
  display: flex;
  transition: 0.3s;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}
.home-more3:hover {
  opacity: 0.5;
}
.home-caption21 {
  color: rgb(255, 255, 255);
  max-width: 600px;
  font-style: normal;
  font-weight: 500;
}
.home-icon14 {
  fill: #ffffff;
  width: 14px;
  height: 14px;
}
.home-image13 {
  height: 400px;
  object-fit: cover;
  aspect-ratio: 1;
}
.home-content14 {
  height: 400px;
  display: flex;
  align-items: flex-start;
  padding-top: var(--dl-space-space-fiveunits);
  padding-left: var(--dl-space-space-threeunits);
  padding-right: var(--dl-space-space-threeunits);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-threeunits);
  justify-content: space-between;
}
.home-header19 {
  gap: var(--dl-space-space-threeunits);
  display: flex;
  flex-direction: column;
}
.home-heading17 {
  color: rgb(255, 255, 255);
  font-size: 40px;
  font-style: normal;
  font-weight: 500;
}
.home-caption22 {
  color: rgb(204, 204, 255);
  max-width: 600px;
  line-height: 24px;
}
.home-more4 {
  gap: 4px;
  cursor: pointer;
  display: flex;
  transition: 0.3s;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}
.home-more4:hover {
  opacity: 0.5;
}
.home-caption23 {
  color: rgb(255, 255, 255);
  max-width: 600px;
  font-style: normal;
  font-weight: 500;
}
.home-icon16 {
  fill: #ffffff;
  width: 14px;
  height: 14px;
}
.home-controls1 {
  gap: var(--dl-space-space-unit);
  display: flex;
  align-items: center;
  flex-direction: row;
}
.home-previous1 {
  display: flex;
  padding-left: var(--dl-space-space-oneandhalfunits);
  padding-right: var(--dl-space-space-oneandhalfunits);
  flex-direction: row;
}
.home-icon18 {
  fill: #ffffff;
  width: 24px;
  height: 24px;
}
.home-next1 {
  display: flex;
  padding-left: var(--dl-space-space-oneandhalfunits);
  padding-right: var(--dl-space-space-oneandhalfunits);
  flex-direction: row;
}
.home-icon20 {
  fill: #ffffff;
  width: 24px;
  height: 24px;
}
.home-container4 {
  display: contents;
}
.home-get-started {
  width: 100%;
  display: flex;
  position: relative;
  max-width: var(--dl-size-size-maxwidth);
  align-items: center;
  padding-top: var(--dl-space-space-fiveunits);
  padding-left: var(--dl-space-space-fiveunits);
  padding-right: var(--dl-space-space-fiveunits);
  flex-direction: row;
  padding-bottom: var(--dl-space-space-fiveunits);
  justify-content: space-between;
}
.home-header-container2 {
  gap: var(--dl-space-space-threeunits);
  display: flex;
  z-index: 100;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
}
.home-header20 {
  gap: var(--dl-space-space-oneandhalfunits);
  width: 100%;
  display: flex;
  max-width: 800px;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
}
.home-heading18 {
  color: rgb(255, 255, 255);
  font-size: 60px;
  font-style: normal;
  font-weight: 400;
}
.home-caption24 {
  color: rgb(255, 255, 255);
  font-size: 24px;
  max-width: 600px;
  line-height: 36px;
}
.home-caption24-2-title {
  color: rgb(255, 255, 255);
  font-size: 24px;
  max-width: 600px;
  line-height: 24px;
  font-style: italic;
  font-family: Playfair Display;
}
.home-caption24-2 {
  color: rgb(255, 255, 255);
  font-size: 24px;
  max-width: 600px;
  line-height: 24px;
  font-size:18px;
}
.home-button2 {
  display: flex;
  align-items: flex-end;
  flex-direction: row;
  justify-content: space-between;
}
.home-image14 {
  top: 0px;
  right: 0px;
  width: 720px;
  bottom: 0px;
  margin: auto;
  position: absolute;
  object-fit: cover;
  /* opacity: 50%; */
}

.home-image14-1 {
  width: 355px;
  object-fit: cover;
  opacity: 50%;
}

.home-image14-2 {
  width: 355px;
  object-fit: cover;
  opacity: 50%;
}

.home-image14-3 {
  width: 720px;
  object-fit: cover;
  opacity: 50%;
}

.image-group{
  right: 0px;
  width: 720px;
  position: absolute;
  display: flex;
  flex-direction: column;
  gap:10px;
}

.image-group-row1{
  width: 720px;
  display: flex;
  flex-direction: row;
  gap:10px;
}

.home-objectives {
  width: 100%;
  display: none;
  max-width: var(--dl-size-size-maxwidth);
  padding-left: var(--dl-space-space-fiveunits);
  padding-right: var(--dl-space-space-fiveunits);
  flex-direction: row;
  justify-content: space-between;
}
.home-content15 {
  flex: 1;
  display: flex;
  align-items: flex-start;
  padding-top: var(--dl-space-space-fiveunits);
  border-color: #313133;
  flex-direction: row;
  padding-bottom: var(--dl-space-space-fiveunits);
  justify-content: space-between;
  border-top-width: 1px;
}
.home-text133 {
  color: #7C7C80;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 5%;
  text-transform: uppercase;
}
.home-objectives-list {
  gap: var(--dl-space-space-threeunits);
  display: flex;
  align-items: flex-start;
  padding-right: var(--dl-space-space-threeunits);
  flex-direction: row;
  justify-content: flex-start;
}
.home-text134 {
  color: rgb(255, 255, 255);
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
}
.home-text135 {
  color: rgb(124, 124, 128);
  line-height: 24px;
}
.home-text136 {
  color: rgb(255, 255, 255);
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
}
.home-text137 {
  color: rgb(124, 124, 128);
  line-height: 24px;
}
.home-text138 {
  color: #ffffff;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
}
.home-text139 {
  color: rgb(124, 124, 128);
  line-height: 24px;
}
.home-growth {
  width: 100%;
  display: none;
  max-width: var(--dl-size-size-maxwidth);
  align-items: flex-start;
  padding-top: var(--dl-space-space-fiveunits);
  padding-left: var(--dl-space-space-fiveunits);
  padding-right: var(--dl-space-space-fiveunits);
  flex-direction: row;
  padding-bottom: var(--dl-space-space-fiveunits);
  justify-content: space-between;
}
.home-content16 {
  gap: var(--dl-space-space-threeunits);
  flex: 1;
  display: flex;
  max-width: 640px;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
}
.home-header21 {
  gap: var(--dl-space-space-oneandhalfunits);
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
}
.home-header22 {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.home-heading19 {
  color: rgb(255, 255, 255);
  font-size: 60px;
  font-style: normal;
  font-weight: 400;
}
.home-text141 {
  font-style: italic;
  font-family: Playfair Display;
  font-weight: 500;
}
.home-caption25 {
  color: #7C7C80;
  width: 100%;
  font-size: 24px;
  max-width: 560px;
  line-height: 36px;
}
.home-caption26 {
  color: rgb(124, 124, 128);
  width: 100%;
  font-size: 24px;
  max-width: 560px;
  line-height: 36px;
  border-color: #313133;
  padding-bottom: var(--dl-space-space-threeunits);
  border-bottom-width: 1px;
}
.home-testimonial1 {
  gap: var(--dl-space-space-oneandhalfunits);
  display: flex;
  position: relative;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
}
.home-content17 {
  gap: var(--dl-space-space-unit);
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
}
.home-text143 {
  color: rgb(124, 124, 128);
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 5%;
  text-transform: uppercase;
}
.home-text144 {
  color: rgb(255, 255, 255);
  font-style: italic;
  font-family: Playfair Display;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 5%;
}
.home-information1 {
  gap: var(--dl-space-space-oneandhalfunits);
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}
.home-author1 {
  gap: var(--dl-space-space-unit);
  display: flex;
  align-items: center;
  border-color: #7C7C80;
  padding-right: var(--dl-space-space-oneandhalfunits);
  flex-direction: row;
  justify-content: center;
  border-right-width: 1px;
}
.home-icon22 {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: var(--dl-radius-radius-round);
}
.home-name1 {
  color: rgb(255, 255, 255);
  font-size: 18px;
  line-height: 27px;
}
.home-from1 {
  width: 125px;
  object-fit: cover;
}
.home-images1 {
  flex: 1;
  display: flex;
  position: relative;
  align-items: flex-end;
  padding-top: var(--dl-space-space-fourunits);
  flex-direction: column;
  justify-content: flex-start;
}
.home-square1 {
  top: 64px;
  right: -35px;
  width: 180px;
  display: flex;
  position: absolute;
  align-items: flex-start;
  aspect-ratio: 1;
  flex-direction: row;
  justify-content: flex-start;
  background-color: #0000FF;
}
.home-image15 {
  width: 640px;
  z-index: 100;
  margin-top: var(--dl-space-space-sixunits);
  object-fit: cover;
}
.home-experience {
  gap: var(--dl-space-space-fourunits);
  width: 100%;
  display: flex;
  max-width: var(--dl-size-size-maxwidth);
  align-items: flex-end;
  padding-top: var(--dl-space-space-fiveunits);
  padding-left: var(--dl-space-space-fiveunits);
  padding-right: var(--dl-space-space-fiveunits);
  flex-direction: row;
  padding-bottom: var(--dl-space-space-fiveunits);
  justify-content: center;
  margin-bottom:140px;
}
.home-images2 {
  flex: 1;
  height: 100%;
  display: flex;
  position: relative;
  align-items: flex-start;
  padding-top: var(--dl-space-space-halfunit);
  flex-direction: column;
  justify-content: flex-end;
}
.home-square2 {
  left: -35px;
  width: 180px;
  bottom: -35px;
  display: flex;
  position: absolute;
  align-items: flex-start;
  aspect-ratio: 1;
  flex-direction: row;
  justify-content: flex-start;
  background-color: var(--dl-color-main-orange-01);
}
.home-image16 {
  width: 575px;
  z-index: 100;
  object-fit: cover;
}
.home-content18 {
  gap: var(--dl-space-space-threeunits);
  width: 100%;
  display: flex;
  max-width: 640px;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
}
.home-header23 {
  gap: var(--dl-space-space-oneandhalfunits);
  width: 100%;
  display: flex;
  align-items: flex-start;
  border-color: #313133;
  flex-direction: column;
  padding-bottom: var(--dl-space-space-threeunits);
  justify-content: center;
  border-bottom-width: 1px;
}
.home-header-container3 {
  gap: var(--dl-space-space-oneandhalfunits);
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
}
.home-header24 {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.home-heading20 {
  color: rgb(255, 255, 255);
  font-size: 50px;
  font-style: normal;
  font-weight: 400;
}
.home-text146 {
  font-family: Playfair Display;
}
.home-caption27 {
  color: rgb(124, 124, 128);
  width: 100%;
  font-size: 24px;
  max-width: 560px;
  line-height: 36px;
}
.home-checkmarks {
  gap: var(--dl-space-space-oneandhalfunits);
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
}
.home-check1 {
  gap: var(--dl-space-space-unit);
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}
.home-mark1 {
  display: flex;
  padding: var(--dl-space-space-halfunit);
  align-items: flex-start;
  border-radius: var(--dl-radius-radius-round);
  flex-direction: column;
  justify-content: center;
  background-color: var(--dl-color-main-orange-01);
}
.home-icon23 {
  fill: #ffffff;
  width: 12px;
  height: 12px;
}
.home-text147 {
  color: rgb(255, 255, 255);
  line-height: 24px;
}
.home-check2 {
  gap: var(--dl-space-space-unit);
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}
.home-mark2 {
  display: flex;
  padding: var(--dl-space-space-halfunit);
  align-items: flex-start;
  border-radius: var(--dl-radius-radius-round);
  flex-direction: column;
  justify-content: center;
  background-color: var(--dl-color-main-orange-01);
}
.home-icon25 {
  fill: #ffffff;
  width: 12px;
  height: 12px;
}
.home-text148 {
  color: rgb(255, 255, 255);
  line-height: 24px;
}
.home-check3 {
  gap: var(--dl-space-space-unit);
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}
.home-mark3 {
  display: flex;
  padding: var(--dl-space-space-halfunit);
  align-items: flex-start;
  border-radius: var(--dl-radius-radius-round);
  flex-direction: column;
  justify-content: center;
  background-color: var(--dl-color-main-orange-01);
}
.home-icon27 {
  fill: #ffffff;
  width: 12px;
  height: 12px;
}
.home-text149 {
  color: rgb(255, 255, 255);
  line-height: 24px;
}
.home-check4 {
  gap: var(--dl-space-space-unit);
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}
.home-mark4 {
  display: flex;
  padding: var(--dl-space-space-halfunit);
  align-items: flex-start;
  border-radius: var(--dl-radius-radius-round);
  flex-direction: column;
  justify-content: center;
  background-color: var(--dl-color-main-orange-01);
}
.home-icon29 {
  fill: #ffffff;
  width: 12px;
  height: 12px;
}
.home-text150 {
  color: rgb(255, 255, 255);
  line-height: 24px;
}
.home-testimonial2 {
  gap: var(--dl-space-space-oneandhalfunits);
  display: flex;
  position: relative;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
}
.home-content19 {
  gap: var(--dl-space-space-unit);
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
}
.home-text151 {
  color: rgb(124, 124, 128);
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 5%;
  text-transform: uppercase;
}
.home-text152 {
  color: rgb(255, 255, 255);
  font-style: italic;
  font-family: Playfair Display;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 5%;
}
.home-information2 {
  gap: var(--dl-space-space-oneandhalfunits);
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}
.home-author2 {
  gap: var(--dl-space-space-unit);
  display: flex;
  align-items: center;
  border-color: #7C7C80;
  padding-right: var(--dl-space-space-oneandhalfunits);
  flex-direction: row;
  justify-content: center;
  border-right-width: 1px;
}
.home-icon31 {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: var(--dl-radius-radius-round);
}
.home-name2 {
  color: rgb(255, 255, 255);
  font-size: 18px;
  line-height: 27px;
}
.home-from2 {
  width: 100px;
  object-fit: cover;
}
.home-create {
  gap: var(--dl-space-space-fourunits);
  width: 100%;
  display: none;
  max-width: var(--dl-size-size-maxwidth);
  align-items: flex-end;
  padding-top: var(--dl-space-space-fiveunits);
  padding-left: var(--dl-space-space-fiveunits);
  padding-right: var(--dl-space-space-fiveunits);
  flex-direction: row;
  padding-bottom: var(--dl-space-space-fiveunits);
  justify-content: center;
}
.home-content20 {
  gap: var(--dl-space-space-threeunits);
  width: 100%;
  display: flex;
  align-items: center;
  padding-top: 120px;
  flex-direction: column;
  padding-bottom: 120px;
  justify-content: center;
  background-color: #0000F5;
}
.home-header25 {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.home-heading21 {
  color: rgb(255, 255, 255);
  font-size: 100px;
  font-style: normal;
  text-align: center;
  font-weight: 500;
}
.home-text154 {
  font-style: italic;
  font-family: Playfair Display;
  font-weight: 500;
}
.home-button4 {
  background-color: #000000;
}
.home-comparision {
  gap: var(--dl-space-space-fiveunits);
  width: 100%;
  display: none;
  max-width: var(--dl-size-size-maxwidth);
  align-items: center;
  padding-top: var(--dl-space-space-fiveunits);
  padding-left: var(--dl-space-space-fiveunits);
  padding-right: var(--dl-space-space-fiveunits);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-fiveunits);
}
.home-header-container4 {
  gap: var(--dl-space-space-oneandhalfunits);
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.home-header26 {
  gap: var(--dl-space-space-oneandhalfunits);
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}
.home-heading22 {
  color: rgb(255, 255, 255);
  font-size: 60px;
  font-style: normal;
  font-weight: 400;
}
.home-caption28 {
  color: rgb(124, 124, 128);
  width: 100%;
  font-size: 24px;
  max-width: 560px;
  text-align: center;
  line-height: 36px;
}
.home-table {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.home-row10 {
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}
.home-headers1 {
  flex: 0.6;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}
.home-text163 {
  color: rgba(255, 255, 255, 0);
  width: 100%;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  padding-top: var(--dl-space-space-oneandhalfunits);
  border-color: #313133;
  padding-bottom: var(--dl-space-space-oneandhalfunits);
  border-bottom-width: 1px;
}
.home-plans1 {
  flex: 1;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}
.home-row11 {
  width: 100%;
  display: flex;
  align-items: center;
  border-color: #313133;
  padding-right: 180px;
  flex-direction: row;
  justify-content: space-between;
  border-bottom-width: 1px;
}
.home-text164 {
  color: rgb(255, 255, 255);
  width: 100%;
  font-size: 14px;
  text-align: center;
  line-height: 32px;
  padding-top: var(--dl-space-space-oneandhalfunits);
  padding-bottom: var(--dl-space-space-oneandhalfunits);
  text-transform: uppercase;
}
.home-text165 {
  color: rgb(255, 255, 255);
  width: 100%;
  font-size: 14px;
  text-align: center;
  line-height: 32px;
  padding-top: var(--dl-space-space-oneandhalfunits);
  padding-bottom: var(--dl-space-space-oneandhalfunits);
  text-transform: uppercase;
}
.home-text166 {
  color: rgb(255, 255, 255);
  width: 100%;
  font-size: 14px;
  text-align: center;
  line-height: 32px;
  padding-top: var(--dl-space-space-oneandhalfunits);
  padding-bottom: var(--dl-space-space-oneandhalfunits);
  text-transform: uppercase;
}
.home-row12 {
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}
.home-headers2 {
  flex: 0.6;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}
.home-text167 {
  color: rgb(255, 255, 255);
  width: 100%;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  padding-top: var(--dl-space-space-oneandhalfunits);
  border-color: #313133;
  padding-bottom: var(--dl-space-space-oneandhalfunits);
  border-bottom-width: 1px;
}
.home-plans2 {
  flex: 1;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}
.home-row13 {
  width: 100%;
  display: flex;
  align-items: center;
  border-color: #313133;
  padding-right: 180px;
  flex-direction: row;
  justify-content: space-between;
  border-bottom-width: 1px;
}
.home-row14 {
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}
.home-headers3 {
  flex: 0.6;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}
.home-text168 {
  color: rgb(255, 255, 255);
  width: 100%;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  padding-top: var(--dl-space-space-oneandhalfunits);
  border-color: #313133;
  padding-bottom: var(--dl-space-space-oneandhalfunits);
  border-bottom-width: 1px;
}
.home-plans3 {
  flex: 1;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}
.home-row15 {
  width: 100%;
  display: flex;
  align-items: center;
  border-color: #313133;
  padding-right: 180px;
  flex-direction: row;
  justify-content: space-between;
  border-bottom-width: 1px;
}
.home-row16 {
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}
.home-headers4 {
  flex: 0.6;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}
.home-text169 {
  color: rgb(255, 255, 255);
  width: 100%;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  padding-top: var(--dl-space-space-oneandhalfunits);
  border-color: #313133;
  padding-bottom: var(--dl-space-space-oneandhalfunits);
  border-bottom-width: 1px;
}
.home-plans4 {
  flex: 1;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}
.home-row17 {
  width: 100%;
  display: flex;
  align-items: center;
  border-color: #313133;
  padding-right: 180px;
  flex-direction: row;
  justify-content: space-between;
  border-bottom-width: 1px;
}
.home-text170 {
  color: rgb(255, 255, 255);
  width: 100%;
  font-size: 14px;
  text-align: center;
  line-height: 32px;
}
.home-row18 {
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}
.home-headers5 {
  flex: 0.6;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}
.home-text171 {
  color: rgb(255, 255, 255);
  width: 100%;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  padding-top: var(--dl-space-space-oneandhalfunits);
  border-color: #313133;
  padding-bottom: var(--dl-space-space-oneandhalfunits);
  border-bottom-width: 1px;
}
.home-plans5 {
  flex: 1;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}
.home-row19 {
  width: 100%;
  display: flex;
  align-items: center;
  border-color: #313133;
  padding-right: 180px;
  flex-direction: row;
  justify-content: space-between;
  border-bottom-width: 1px;
}
.home-text172 {
  color: rgb(255, 255, 255);
  width: 100%;
  font-size: 14px;
  text-align: center;
  line-height: 32px;
}
.home-text173 {
  color: rgb(255, 255, 255);
  width: 100%;
  font-size: 14px;
  text-align: center;
  line-height: 32px;
}
.home-row20 {
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}
.home-headers6 {
  flex: 0.6;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}
.home-text174 {
  color: rgb(255, 255, 255);
  width: 100%;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  padding-top: var(--dl-space-space-oneandhalfunits);
  border-color: #313133;
  padding-bottom: var(--dl-space-space-oneandhalfunits);
  border-bottom-width: 1px;
}
.home-plans6 {
  flex: 1;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}
.home-row21 {
  width: 100%;
  display: flex;
  align-items: center;
  border-color: #313133;
  padding-right: 180px;
  flex-direction: row;
  justify-content: space-between;
  border-bottom-width: 1px;
}
.home-text175 {
  color: rgb(255, 255, 255);
  width: 100%;
  font-size: 14px;
  text-align: center;
  line-height: 32px;
}
.home-row22 {
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}
.home-headers7 {
  flex: 0.6;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}
.home-text176 {
  color: rgb(255, 255, 255);
  width: 100%;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  padding-top: var(--dl-space-space-oneandhalfunits);
  border-color: #313133;
  padding-bottom: var(--dl-space-space-oneandhalfunits);
  border-bottom-width: 1px;
}
.home-plans7 {
  flex: 1;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}
.home-row23 {
  width: 100%;
  display: flex;
  align-items: center;
  border-color: #313133;
  padding-right: 180px;
  flex-direction: row;
  justify-content: space-between;
  border-bottom-width: 1px;
}
.home-row24 {
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}
.home-headers8 {
  flex: 0.6;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}
.home-text177 {
  color: rgb(255, 255, 255);
  width: 100%;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  padding-top: var(--dl-space-space-oneandhalfunits);
  border-color: #313133;
  padding-bottom: var(--dl-space-space-oneandhalfunits);
  border-bottom-width: 1px;
}
.home-plans8 {
  flex: 1;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}
.home-row25 {
  width: 100%;
  display: flex;
  align-items: center;
  border-color: #313133;
  padding-right: 180px;
  flex-direction: row;
  justify-content: space-between;
  border-bottom-width: 1px;
}
.home-text178 {
  color: rgb(255, 255, 255);
  width: 100%;
  font-size: 14px;
  text-align: center;
  line-height: 32px;
}
.home-data {
  gap: var(--dl-space-space-fiveunits);
  width: 100%;
  display: none;
  max-width: var(--dl-size-size-maxwidth);
  align-items: flex-start;
  padding-top: var(--dl-space-space-fiveunits);
  padding-left: var(--dl-space-space-fiveunits);
  padding-right: var(--dl-space-space-fiveunits);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-fiveunits);
}
.home-header-container5 {
  gap: var(--dl-space-space-oneandhalfunits);
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.home-header27 {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.home-row26 {
  gap: var(--dl-space-space-oneandhalfunits);
  display: flex;
  align-items: center;
  flex-direction: row;
}
.home-heading23 {
  color: rgb(255, 255, 255);
  font-size: 60px;
  font-style: normal;
  font-weight: 400;
}
.home-caption29 {
  color: rgb(124, 124, 128);
  width: 100%;
  font-size: 24px;
  max-width: 600px;
  line-height: 36px;
}
.home-content21 {
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  justify-content: space-between;
}
.home-image17 {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.home-image18 {
  width: 440px;
  object-fit: cover;
}
.home-accordion {
  width: 100%;
  display: flex;
  max-width: 640px;
  align-items: flex-start;
  flex-direction: column;
  justify-content: space-between;
}
.home-header28 {
  color: rgb(255, 255, 255);
  font-size: 40px;
  font-style: normal;
  font-weight: 500;
}
.home-header29 {
  color: rgb(255, 255, 255);
  font-size: 40px;
  font-style: normal;
  font-weight: 500;
}
.home-header30 {
  color: rgb(255, 255, 255);
  font-size: 40px;
  font-style: normal;
  font-weight: 500;
}
.home-header31 {
  color: rgb(255, 255, 255);
  font-size: 40px;
  font-style: normal;
  font-weight: 500;
}
.home-container6 {
  display: contents;
}
.home-customer {
  gap: var(--dl-space-space-fiveunits);
  width: 100%;
  display: none;
  align-items: flex-start;
  flex-direction: column;
  padding-bottom: var(--dl-space-space-sixunits);
}
.home-header32 {
  width: 100%;
  display: flex;
  max-width: var(--dl-size-size-maxwidth);
  align-self: center;
  flex-direction: column;
}
.home-heading24 {
  color: rgb(255, 255, 255);
  font-size: 60px;
  max-width: 900px;
  font-style: normal;
  font-weight: 400;
  padding-left: var(--dl-space-space-fiveunits);
  padding-right: var(--dl-space-space-fiveunits);
}
.home-text183 {
  font-style: italic;
  font-family: Playfair Display;
  font-weight: 500;
}
.home-quotes {
  width: 100%;
  display: flex;
  position: relative;
  overflow-x: hidden;
  align-items: flex-start;
  margin-left: max(0px, (100% - 1240px)/2);
  padding-top: var(--dl-space-space-threeunits);
  border-color: rgba(255, 255, 255, 0.2);
  flex-direction: row;
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.home-quote1 {
  gap: var(--dl-space-space-threeunits);
  height: 100%;
  display: flex;
  align-items: flex-start;
  border-color: rgba(255, 255, 255, 0.2);
  padding-right: var(--dl-space-space-threeunits);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-threeunits);
  border-right-width: 1px;
}
.home-quote2 {
  color: rgb(124, 124, 128);
  width: 100%;
  font-size: 16px;
  max-width: 400px;
  line-height: 24px;
  letter-spacing: 1%;
}
.home-author3 {
  gap: 4px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.home-name3 {
  color: rgb(255, 255, 255);
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 30px;
  letter-spacing: 1%;
}
.home-location1 {
  color: rgba(255, 255, 255, 0.3);
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 1%;
}
.home-quote3 {
  gap: var(--dl-space-space-threeunits);
  height: 100%;
  display: flex;
  align-items: flex-start;
  border-color: rgba(255, 255, 255, 0.2);
  padding-left: var(--dl-space-space-threeunits);
  padding-right: var(--dl-space-space-threeunits);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-threeunits);
  border-right-width: 1px;
}
.home-quote4 {
  color: rgb(124, 124, 128);
  width: 100%;
  font-size: 16px;
  max-width: 400px;
  line-height: 24px;
  letter-spacing: 1%;
}
.home-author4 {
  gap: 4px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.home-name4 {
  color: rgb(255, 255, 255);
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 30px;
  letter-spacing: 1%;
}
.home-location2 {
  color: rgba(255, 255, 255, 0.3);
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 1%;
}
.home-quote5 {
  gap: var(--dl-space-space-threeunits);
  height: 100%;
  display: flex;
  align-items: flex-start;
  border-color: rgba(255, 255, 255, 0.2);
  padding-left: var(--dl-space-space-threeunits);
  padding-right: var(--dl-space-space-threeunits);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-threeunits);
  border-right-width: 1px;
}
.home-quote6 {
  color: rgb(124, 124, 128);
  width: 100%;
  font-size: 16px;
  max-width: 400px;
  line-height: 24px;
  letter-spacing: 1%;
}
.home-author5 {
  gap: 4px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.home-name5 {
  color: rgb(255, 255, 255);
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 30px;
  letter-spacing: 1%;
}
.home-location3 {
  color: rgba(255, 255, 255, 0.3);
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 1%;
}
.home-quote7 {
  gap: var(--dl-space-space-threeunits);
  height: 100%;
  display: flex;
  align-items: flex-start;
  border-color: rgba(255, 255, 255, 0.2);
  padding-left: var(--dl-space-space-threeunits);
  padding-right: var(--dl-space-space-threeunits);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-threeunits);
  border-right-width: 1px;
}
.home-quote8 {
  color: rgb(124, 124, 128);
  width: 100%;
  font-size: 16px;
  max-width: 400px;
  line-height: 24px;
  letter-spacing: 1%;
}
.home-author6 {
  gap: 4px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.home-name6 {
  color: rgb(255, 255, 255);
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 30px;
  letter-spacing: 1%;
}
.home-location4 {
  color: rgba(255, 255, 255, 0.3);
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 1%;
}
.home-controls2 {
  gap: var(--dl-space-space-unit);
  width: 100%;
  display: flex;
  max-width: var(--dl-size-size-maxwidth);
  align-self: center;
  align-items: center;
  padding-left: var(--dl-space-space-fiveunits);
  padding-right: var(--dl-space-space-fiveunits);
  flex-direction: row;
}
.home-previous2 {
  display: flex;
  padding-left: var(--dl-space-space-oneandhalfunits);
  padding-right: var(--dl-space-space-oneandhalfunits);
  flex-direction: row;
}
.home-icon32 {
  fill: #ffffff;
  width: 24px;
  height: 24px;
}
.home-next2 {
  display: flex;
  padding-left: var(--dl-space-space-oneandhalfunits);
  padding-right: var(--dl-space-space-oneandhalfunits);
  flex-direction: row;
}
.home-icon34 {
  fill: #ffffff;
  width: 24px;
  height: 24px;
}
.home-about-vhex {
  margin-top:70px;
  gap: var(--dl-space-space-threeunits);
  width: 100%;
  height: 807px;
  display: flex;
  max-width: auto;
  align-items: flex-start;
  padding-top: 75px;
  padding-left: 59px;
  padding-right: var(--dl-space-space-fiveunits);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-fourunits);
  justify-content: center;
}
.home-content30 {
  gap: 120px;
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  justify-content: center;
}
.home-column1 {
  gap: var(--dl-space-space-fourunits);
  width: 1371px;
  height: 406px;
  display: flex;
  position: relative;
  max-width: auto;
  align-items: flex-start;
  flex-direction: row;
  justify-content: center;
}
.home-element5 {
  gap: var(--dl-space-space-oneandhalfunits);
  width: 700px;
  cursor: pointer;
  display: flex;
  align-self: center;
  align-items: flex-start;
  flex-direction: column;
  padding-bottom: var(--dl-space-space-threeunits);
  justify-content: flex-start;
}
.home-heading25 {
  color: rgb(255, 255, 255);
  width: 1341px;
  margin-top: 50px;
  text-align: left;
}
.home-text189 {
  font-style: normal;
}
.home-header33 {
  color: rgb(255, 255, 255);
  font-size: 22px;
  font-style: italic;
  font-family: "Playfair Display";
  font-weight: 700;
}
.home-text193 {
  color: rgb(255, 255, 255);
  width: 660px;
  font-size: 18px;
  text-align: justify;
  font-family: "Open Sans";
  font-weight: 400;
  line-height: 1.5;
  text-transform: none;
  text-decoration: none;
}
.home-image19 {
  width: 770px;
  height: 100%;
  box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.23);
  object-fit: cover;
  border-radius: var(--dl-radius-radius-radius8);
}
.home-footer {
  width: 100%;
  display: flex;
  max-width: auto;
  align-items: flex-start;
  padding-left: var(--dl-space-space-fiveunits);
  padding-right: var(--dl-space-space-fiveunits);
  flex-direction: column;
}
.home-content31 {
  gap: var(--dl-space-space-fiveunits);
  width: 100%;
  display: flex;
  align-items: center;
  padding-top: var(--dl-space-space-fiveunits);
  border-color: #313133;
  flex-direction: column;
  padding-bottom: var(--dl-space-space-fiveunits);
  border-top-width: 1px;
}
.home-main {
  gap: 240px;
  width: 1318px;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  justify-content: flex-start;
}
.home-branding {
  gap: var(--dl-space-space-twounits);
  width: 418px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.home-image20 {
  width: 309px;
  height: 96px;
  object-fit: cover;
}
.home-container7 {
  gap: var(--dl-space-space-unit);
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.home-frame1 {
  gap: var(--dl-space-space-halfunit);
  width: 546px;
  height: auto;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  justify-content: flex-start;
}
.home-icon36 {
  fill: #ffffff;
  width: 28px;
  height: 35px;
}
.home-text201 {
  color: rgba(255, 255, 255, 1);
  height: auto;
  text-align: left;
  font-stretch: normal;
}
.home-text206 {
  color: #ffffff;
}
.home-frame2 {
  gap: var(--dl-space-space-halfunit);
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
}
.home-icon38 {
  fill: #ffffff;
  width: 24px;
  height: 24px;
}
.home-text207 {
  color: rgba(255, 255, 255, 1);
  height: auto;
  text-align: left;
  font-stretch: normal;
}
.home-frame3 {
  gap: var(--dl-space-space-halfunit);
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
}
.home-icon40 {
  fill: #ffffff;
  width: 24px;
  height: 24px;
}
.home-text209 {
  color: rgba(255, 255, 255, 1);
  height: auto;
  text-align: left;
  font-stretch: normal;
}
.home-links {
  gap: 120px;
  width: 787px;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  justify-content: flex-end;
}
.home-column2 {
  gap: var(--dl-space-space-threeunits);
  color: white;
  display: none;
  align-items: flex-start;
  flex-direction: column;
}
.home-header34 {
  font-size: 24px;
  font-style: italic;
  font-family: Playfair Display;
  font-weight: 500;
}
.home-list1 {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.home-navlink10 {
  cursor: pointer;
  font-size: 16px;
  transition: 0.3s;
  line-height: 32px;
  text-decoration: none;
}
.home-navlink10:hover {
  opacity: .5;
}
.home-navlink11 {
  cursor: pointer;
  font-size: 16px;
  transition: 0.3s;
  line-height: 32px;
  text-decoration: none;
}
.home-navlink11:hover {
  opacity: .5;
}
.home-navlink12 {
  cursor: pointer;
  font-size: 16px;
  transition: 0.3s;
  line-height: 32px;
  text-decoration: none;
}
.home-navlink12:hover {
  opacity: .5;
}
.home-navlink13 {
  cursor: pointer;
  font-size: 16px;
  transition: 0.3s;
  line-height: 32px;
  text-decoration: none;
}
.home-navlink13:hover {
  opacity: .5;
}
.home-text211:hover {
  opacity: .5;
}
.home-column3 {
  gap: var(--dl-space-space-threeunits);
  color: white;
  display: none;
  align-items: flex-start;
  flex-direction: column;
}
.home-header35 {
  font-size: 24px;
  font-style: italic;
  font-family: Playfair Display;
  font-weight: 500;
}
.home-list2 {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.home-navlink14 {
  cursor: pointer;
  font-size: 16px;
  transition: 0.3s;
  line-height: 32px;
  text-decoration: none;
}
.home-navlink14:hover {
  opacity: .5;
}
.home-navlink15 {
  cursor: pointer;
  font-size: 16px;
  transition: 0.3s;
  line-height: 32px;
  text-decoration: none;
}
.home-navlink15:hover {
  opacity: .5;
}
.home-navlink16 {
  cursor: pointer;
  font-size: 16px;
  transition: 0.3s;
  line-height: 32px;
  text-decoration: none;
}
.home-navlink16:hover {
  opacity: .5;
}
.home-navlink17 {
  cursor: pointer;
  font-size: 16px;
  transition: 0.3s;
  line-height: 32px;
  text-decoration: none;
}
.home-navlink17:hover {
  opacity: .5;
}
.home-navlink18 {
  cursor: pointer;
  font-size: 16px;
  transition: 0.3s;
  line-height: 32px;
  text-decoration: none;
}
.home-navlink18:hover {
  opacity: .5;
}
.home-navlink19 {
  cursor: pointer;
  font-size: 16px;
  transition: 0.3s;
  line-height: 32px;
  text-decoration: none;
}
.home-navlink19:hover {
  opacity: .5;
}
.home-navlink20 {
  cursor: pointer;
  font-size: 16px;
  transition: 0.3s;
  line-height: 32px;
  text-decoration: none;
}
.home-navlink20:hover {
  opacity: .5;
}
.home-column4 {
  gap: var(--dl-space-space-threeunits);
  color: white;
  display: none;
  align-items: flex-start;
  flex-direction: column;
}
.home-header36 {
  font-size: 24px;
  font-style: italic;
  font-family: Playfair Display;
  font-weight: 500;
}
.home-list3 {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.home-navlink21 {
  cursor: pointer;
  font-size: 16px;
  transition: 0.3s;
  line-height: 32px;
  text-decoration: none;
}
.home-navlink21:hover {
  opacity: .5;
}
.home-navlink22 {
  cursor: pointer;
  font-size: 16px;
  transition: 0.3s;
  line-height: 32px;
  text-decoration: none;
}
.home-navlink22:hover {
  opacity: .5;
}
.home-navlink23 {
  cursor: pointer;
  font-size: 16px;
  transition: 0.3s;
  line-height: 32px;
  text-decoration: none;
}
.home-navlink23:hover {
  opacity: .5;
}
.home-navlink24 {
  cursor: pointer;
  font-size: 16px;
  transition: 0.3s;
  line-height: 32px;
  text-decoration: none;
}
.home-navlink24:hover {
  opacity: .5;
}
.home-navlink25 {
  cursor: pointer;
  font-size: 16px;
  transition: 0.3s;
  line-height: 32px;
  text-decoration: none;
}
.home-navlink25:hover {
  opacity: .5;
}
.home-button6 {
  display: flex;
  padding-top: var(--dl-space-space-unit);
  padding-left: var(--dl-space-space-fiveunits);
  border-radius: 0px;
  padding-right: var(--dl-space-space-fiveunits);
  flex-direction: row;
  padding-bottom: var(--dl-space-space-unit);
  justify-content: flex-end;
  background-color: var(--dl-color-main-navy-01);
}
.home-image21 {
  width: 21px;
  object-fit: cover;
}
.home-bottom {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}
.home-text213 {
  color: rgb(124, 124, 128);
  text-align: center;
}
.home-container9 {
  display: contents;
}
@media(max-width: 1600px) {
  .home-content10 {
    width: 1559px;
  }
  .home-stat1 {
    width: 547px;
  }
  .home-stat2 {
    width: 480px;
  }
  .home-header14 {
    width: 533px;
  }
}
@media(max-width: 1200px) {
  .home-content30 {
    height: 780px;
  }
  .home-column1 {
    height: 728px;
    flex-direction: column;
  }
}
@media(max-width: 991px) {
  .home-hero {
    padding-left: var(--dl-space-space-oneandhalfunits);
  }
  .home-hero-content {
    padding-right: var(--dl-space-space-oneandhalfunits);
  }
  .home-content10 {
    padding-top: var(--dl-space-space-oneandhalfunits);
    flex-direction: column;
  }
  .home-stat1 {
    width: 100%;
    padding-bottom: var(--dl-space-space-oneandhalfunits);
    border-right-width: 0px;
    border-bottom-width: 1px;
  }
  .home-stat2 {
    width: 100%;
    padding-top: var(--dl-space-space-oneandhalfunits);
    padding-bottom: var(--dl-space-space-oneandhalfunits);
    border-right-width: 0px;
    border-bottom-width: 1px;
  }
  .home-stat3 {
    width: 100%;
    padding-top: var(--dl-space-space-oneandhalfunits);
    padding-bottom: var(--dl-space-space-oneandhalfunits);
  }
  .home-selector {
    gap: var(--dl-space-space-twounits);
    align-items: flex-start;
    flex-direction: column;
    justify-content: flex-start;
  }
  .home-slider2 {
    gap: var(--dl-space-space-twounits);
  }
  .home-image10 {
    width: 100%;
    height: 120px;
  }
  .home-content11 {
    gap: var(--dl-space-space-unit);
    width: 100%;
    height: auto;
    padding-top: var(--dl-space-space-oneandhalfunits);
    padding-left: var(--dl-space-space-oneandhalfunits);
    padding-right: var(--dl-space-space-oneandhalfunits);
    padding-bottom: var(--dl-space-space-oneandhalfunits);
    justify-content: flex-start;
  }
  .home-header16 {
    gap: var(--dl-space-space-halfunit);
    width: 100%;
  }
  .home-heading14 {
    font-size: 24px;
  }
  .home-caption16 {
    max-width: 600px;
  }
  .home-image11 {
    width: 100%;
    height: 120px;
  }
  .home-content12 {
    gap: var(--dl-space-space-unit);
    width: 100%;
    height: auto;
    padding-top: var(--dl-space-space-oneandhalfunits);
    padding-left: var(--dl-space-space-oneandhalfunits);
    padding-right: var(--dl-space-space-oneandhalfunits);
    padding-bottom: var(--dl-space-space-oneandhalfunits);
    justify-content: flex-start;
  }
  .home-header17 {
    gap: var(--dl-space-space-halfunit);
    width: 100%;
  }
  .home-heading15 {
    font-size: 24px;
  }
  .home-caption18 {
    max-width: 600px;
  }
  .home-image12 {
    width: 100%;
    height: 120px;
  }
  .home-content13 {
    gap: var(--dl-space-space-unit);
    width: 100%;
    height: auto;
    padding-top: var(--dl-space-space-oneandhalfunits);
    padding-left: var(--dl-space-space-oneandhalfunits);
    padding-right: var(--dl-space-space-oneandhalfunits);
    padding-bottom: var(--dl-space-space-oneandhalfunits);
    justify-content: flex-start;
  }
  .home-header18 {
    gap: var(--dl-space-space-halfunit);
    width: 100%;
  }
  .home-heading16 {
    font-size: 24px;
  }
  .home-caption20 {
    max-width: 600px;
  }
  .home-image13 {
    width: 100%;
    height: 120px;
  }
  .home-content14 {
    gap: var(--dl-space-space-unit);
    width: 100%;
    height: auto;
    padding-top: var(--dl-space-space-oneandhalfunits);
    padding-left: var(--dl-space-space-oneandhalfunits);
    padding-right: var(--dl-space-space-oneandhalfunits);
    padding-bottom: var(--dl-space-space-oneandhalfunits);
    justify-content: flex-start;
  }
  .home-header19 {
    gap: var(--dl-space-space-halfunit);
    width: 100%;
  }
  .home-heading17 {
    font-size: 24px;
  }
  .home-caption22 {
    max-width: 600px;
  }
  .home-content15 {
    gap: var(--dl-space-space-oneandhalfunits);
    flex-direction: column;
    justify-content: flex-start;
  }
  .home-objectives-list {
    padding-right: 0px;
  }
  .home-objective2 {
    flex: 1;
  }
  .home-objective3 {
    flex: 1;
  }
  .home-growth {
    flex-direction: column;
  }
  .home-testimonial1 {
    padding-bottom: var(--dl-space-space-threeunits);
  }
  .home-text144 {
    max-width: 560px;
  }
  .home-images1 {
    padding-top: 0px;
  }
  .home-square1 {
    top: -20px;
    right: -20px;
  }
  .home-image15 {
    margin-top: 0px;
  }
  .home-experience {
    align-items: flex-start;
    flex-direction: column-reverse;
  }
  .home-content20 {
    gap: var(--dl-space-space-twounits);
    padding-top: var(--dl-space-space-fourunits);
    padding-bottom: var(--dl-space-space-fourunits);
  }
  .home-heading21 {
    font-size: 50px;
  }
  .home-headers1 {
    flex: 0;
  }
  .home-text163 {
    color: rgba(255, 255, 255, 0);
    width: 0px;
    font-style: normal;
    font-weight: 500;
    line-height: 32px;
  }
  .home-row11 {
    padding-right: 0px;
    justify-content: center;
  }
  .home-row12 {
    flex-direction: column;
  }
  .home-headers2 {
    flex: 0 0 auto;
    width: 100%;
  }
  .home-text167 {
    padding-top: var(--dl-space-space-halfunit);
    padding-bottom: var(--dl-space-space-unit);
    border-bottom-width: 0px;
  }
  .home-plans2 {
    width: 100%;
  }
  .home-row13 {
    padding-right: 0px;
  }
  .home-row14 {
    flex-direction: column;
  }
  .home-headers3 {
    flex: 0 0 auto;
    width: 100%;
  }
  .home-text168 {
    width: 100%;
    padding-top: var(--dl-space-space-halfunit);
    padding-bottom: var(--dl-space-space-unit);
    border-bottom-width: 0px;
  }
  .home-plans3 {
    width: 100%;
  }
  .home-row15 {
    padding-right: 0px;
  }
  .home-row16 {
    flex-direction: column;
  }
  .home-headers4 {
    flex: 0 0 auto;
    width: 100%;
  }
  .home-text169 {
    padding-top: var(--dl-space-space-halfunit);
    padding-bottom: var(--dl-space-space-unit);
    border-bottom-width: 0px;
  }
  .home-plans4 {
    width: 100%;
  }
  .home-row17 {
    padding-right: 0px;
  }
  .home-row18 {
    flex-direction: column;
  }
  .home-headers5 {
    flex: 0 0 auto;
    width: 100%;
  }
  .home-text171 {
    padding-top: var(--dl-space-space-halfunit);
    padding-bottom: var(--dl-space-space-unit);
    border-bottom-width: 0px;
  }
  .home-plans5 {
    width: 100%;
  }
  .home-row19 {
    padding-right: 0px;
  }
  .home-row20 {
    flex-direction: column;
  }
  .home-headers6 {
    flex: 0 0 auto;
    width: 100%;
  }
  .home-text174 {
    padding-top: var(--dl-space-space-halfunit);
    padding-bottom: var(--dl-space-space-unit);
    border-bottom-width: 0px;
  }
  .home-plans6 {
    width: 100%;
  }
  .home-row21 {
    padding-right: 0px;
  }
  .home-row22 {
    flex-direction: column;
  }
  .home-headers7 {
    flex: 0 0 auto;
    width: 100%;
  }
  .home-text176 {
    padding-top: var(--dl-space-space-halfunit);
    padding-bottom: var(--dl-space-space-unit);
    border-bottom-width: 0px;
  }
  .home-plans7 {
    width: 100%;
  }
  .home-row23 {
    padding-right: 0px;
  }
  .home-row24 {
    flex-direction: column;
  }
  .home-headers8 {
    flex: 0 0 auto;
    width: 100%;
  }
  .home-text177 {
    padding-top: var(--dl-space-space-halfunit);
    padding-bottom: var(--dl-space-space-unit);
    border-bottom-width: 0px;
  }
  .home-plans8 {
    width: 100%;
  }
  .home-row25 {
    padding-right: 0px;
  }
  .home-heading23 {
    color: rgb(255, 255, 255);
  }
  .home-text180 {
    font-style: italic;
    font-family: Playfair Display;
    font-weight: 500;
  }
  .home-content21 {
    gap: var(--dl-space-space-oneandhalfunits);
    flex-direction: column;
    justify-content: flex-start;
  }
  .home-header28 {
    font-size: 24px;
  }
  .home-header29 {
    font-size: 24px;
  }
  .home-header30 {
    font-size: 24px;
  }
  .home-header31 {
    font-size: 24px;
  }
  .home-customer {
    max-width: 1400px;
    padding-left: var(--dl-space-space-fiveunits);
    padding-right: var(--dl-space-space-fiveunits);
  }
  .home-header32 {
    max-width: 100%;
  }
  .home-heading24 {
    padding-left: 0px;
    padding-right: 0px;
  }
  .home-quotes {
    padding-top: 0px;
    flex-direction: column;
    border-bottom-width: 0px;
  }
  .home-quote1 {
    gap: var(--dl-space-space-oneandhalfunits);
    width: 100%;
    padding-top: var(--dl-space-space-oneandhalfunits);
    padding-right: 0px;
    padding-bottom: var(--dl-space-space-oneandhalfunits);
    border-right-width: 0px;
    border-bottom-width: 1px;
  }
  .home-quote2 {
    font-size: 16px;
    max-width: 100%;
  }
  .home-quote3 {
    gap: var(--dl-space-space-oneandhalfunits);
    width: 100%;
    padding-top: var(--dl-space-space-oneandhalfunits);
    padding-left: 0px;
    padding-right: 0px;
    padding-bottom: var(--dl-space-space-oneandhalfunits);
    border-right-width: 0px;
    border-bottom-width: 1px;
  }
  .home-quote4 {
    font-size: 16px;
    max-width: 100%;
  }
  .home-quote5 {
    gap: var(--dl-space-space-oneandhalfunits);
    width: 100%;
    padding-top: var(--dl-space-space-oneandhalfunits);
    padding-left: 0px;
    padding-right: 0px;
    padding-bottom: var(--dl-space-space-oneandhalfunits);
    border-right-width: 0px;
    border-bottom-width: 1px;
  }
  .home-quote6 {
    font-size: 16px;
    max-width: 100%;
  }
  .home-quote7 {
    gap: var(--dl-space-space-oneandhalfunits);
    width: 100%;
    padding-top: var(--dl-space-space-oneandhalfunits);
    padding-left: 0px;
    padding-right: 0px;
    padding-bottom: var(--dl-space-space-oneandhalfunits);
    border-right-width: 0px;
    border-bottom-width: 1px;
  }
  .home-quote8 {
    font-size: 16px;
    max-width: 100%;
  }
  .home-controls2 {
    max-width: 100%Width;
    padding-left: 0px;
    padding-right: 0px;
  }
  .home-previous2 {
    display: none;
  }
  .home-next2 {
    display: none;
  }
  .home-about-vhex {
    padding-bottom: var(--dl-space-space-fiveunits);
  }
  .home-content30 {
    gap: var(--dl-space-space-oneandhalfunits);
    flex-direction: column;
    justify-content: flex-start;
  }
  .home-column1 {
    max-width: 100%;
  }
  .home-header33 {
    font-size: 24px;
  }
  .home-content31 {
    border-top-width: 0px;
  }
  .home-main {
    gap: var(--dl-space-space-threeunits);
    flex-direction: column;
  }
  .home-branding {
    width: 100%;
  }
}
@media(max-width: 767px) {
  .home-heading10 {
    font-size: 60px;
  }
  .home-heading11 {
    font-size: 60px;
  }
  .home-note {
    align-items: flex-start;
    padding-top: var(--dl-space-space-threeunits);
    padding-left: var(--dl-space-space-oneandhalfunits);
    padding-right: var(--dl-space-space-oneandhalfunits);
    padding-bottom: var(--dl-space-space-fourunits);
  }
  .home-caption11 {
    font-size: 18px;
    max-width: 90%;
    line-height: 23px;
    margin-right: 0px;
  }
  .home-statistics {
    padding-left: var(--dl-space-space-oneandhalfunits);
    padding-right: var(--dl-space-space-oneandhalfunits);
    padding-bottom: var(--dl-space-space-threeunits);
  }
  .home-stat1 {
    gap: var(--dl-space-space-unit);
  }
  .home-caption12 {
    font-size: 14px;
    line-height: 21px;
  }
  .home-stat2 {
    gap: var(--dl-space-space-unit);
  }
  .home-caption13 {
    font-size: 14px;
    line-height: 21px;
  }
  .home-stat3 {
    gap: var(--dl-space-space-unit);
  }
  .home-caption14 {
    font-size: 14px;
    line-height: 21px;
  }
  .home-slider1 {
    padding-top: var(--dl-space-space-threeunits);
    padding-left: var(--dl-space-space-oneandhalfunits);
    padding-right: var(--dl-space-space-oneandhalfunits);
    padding-bottom: var(--dl-space-space-threeunits);
  }
  .home-heading13 {
    font-size: 40px;
  }
  .home-caption15 {
    font-size: 16px;
    line-height: 24px;
  }
  .home-slide-titles {
    gap: var(--dl-space-space-oneandhalfunits);
  }
  .home-slides {
    gap: var(--dl-space-space-oneandhalfunits);
  }
  .home-slider2 {
    gap: var(--dl-space-space-oneandhalfunits);
  }
  .home-slider-track {
    align-items: stretch;
  }
  .home-heading14 {
    font-size: 18px;
  }
  .home-caption16 {
    font-size: 12px;
    line-height: 18px;
  }
  .home-caption17 {
    font-size: 14px;
  }
  .home-icon10 {
    width: 11px;
    height: 11px;
  }
  .home-heading15 {
    font-size: 18px;
  }
  .home-caption18 {
    font-size: 12px;
    line-height: 18px;
  }
  .home-caption19 {
    font-size: 14px;
  }
  .home-icon12 {
    width: 11px;
    height: 11px;
  }
  .home-heading16 {
    font-size: 18px;
  }
  .home-caption20 {
    font-size: 12px;
    line-height: 18px;
  }
  .home-caption21 {
    font-size: 14px;
  }
  .home-icon14 {
    width: 11px;
    height: 11px;
  }
  .home-heading17 {
    font-size: 18px;
  }
  .home-caption22 {
    font-size: 12px;
    line-height: 18px;
  }
  .home-caption23 {
    font-size: 14px;
  }
  .home-icon16 {
    width: 11px;
    height: 11px;
  }
  .home-previous1 {
    padding-top: var(--dl-space-space-unit);
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
    padding-bottom: var(--dl-space-space-unit);
  }
  .home-icon18 {
    width: 14px;
    height: 14px;
  }
  .home-next1 {
    padding-top: var(--dl-space-space-unit);
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
    padding-bottom: var(--dl-space-space-unit);
  }
  .home-icon20 {
    width: 14px;
    height: 14px;
  }
  .home-get-started {
    padding-top: var(--dl-space-space-threeunits);
    padding-left: var(--dl-space-space-oneandhalfunits);
    padding-right: var(--dl-space-space-oneandhalfunits);
    padding-bottom: var(--dl-space-space-threeunits);
  }
  .home-heading18 {
    font-size: 36px;
    line-height: 42px;
  }
  .home-caption24 {
    font-size: 16px;
    line-height: 24px;
  }
  .home-image14 {
    width: 300px;
  }
  .home-objectives {
    padding-left: var(--dl-space-space-oneandhalfunits);
    padding-right: var(--dl-space-space-oneandhalfunits);
  }
  .home-content15 {
    padding-top: var(--dl-space-space-threeunits);
    padding-bottom: var(--dl-space-space-threeunits);
  }
  .home-objectives-list {
    width: 100%;
    flex-direction: column;
  }
  .home-growth {
    padding-top: var(--dl-space-space-threeunits);
    padding-left: var(--dl-space-space-oneandhalfunits);
    padding-right: var(--dl-space-space-oneandhalfunits);
    padding-bottom: var(--dl-space-space-threeunits);
  }
  .home-content16 {
    gap: var(--dl-space-space-oneandhalfunits);
  }
  .home-header21 {
    gap: var(--dl-space-space-unit);
  }
  .home-heading19 {
    font-size: 40px;
  }
  .home-caption25 {
    font-size: 16px;
    line-height: 24px;
  }
  .home-caption26 {
    font-size: 16px;
    line-height: 24px;
    padding-bottom: var(--dl-space-space-oneandhalfunits);
  }
  .home-text143 {
    font-size: 12px;
    line-height: 18px;
  }
  .home-icon22 {
    width: 40px;
    height: 40px;
  }
  .home-name1 {
    font-size: 12px;
    line-height: 18px;
  }
  .home-from1 {
    width: auto;
    height: 100%;
  }
  .home-image15 {
    width: 100%;
  }
  .home-experience {
    padding-top: var(--dl-space-space-threeunits);
    padding-left: var(--dl-space-space-oneandhalfunits);
    padding-right: var(--dl-space-space-oneandhalfunits);
    padding-bottom: var(--dl-space-space-threeunits);
  }
  .home-square2 {
    left: -20px;
    width: 20%;
    bottom: -20px;
  }
  .home-image16 {
    width: 100%;
  }
  .home-content18 {
    gap: var(--dl-space-space-oneandhalfunits);
  }
  .home-header23 {
    padding-bottom: var(--dl-space-space-oneandhalfunits);
  }
  .home-header-container3 {
    gap: var(--dl-space-space-unit);
  }
  .home-heading20 {
    font-size: 40px;
  }
  .home-caption27 {
    font-size: 16px;
    line-height: 24px;
  }
  .home-text151 {
    font-size: 12px;
    line-height: 18px;
  }
  .home-icon31 {
    width: 40px;
    height: 40px;
  }
  .home-name2 {
    font-size: 12px;
    line-height: 18px;
  }
  .home-from2 {
    width: auto;
    height: 100%;
  }
  .home-create {
    padding-top: var(--dl-space-space-threeunits);
    padding-left: var(--dl-space-space-oneandhalfunits);
    padding-right: var(--dl-space-space-oneandhalfunits);
    padding-bottom: var(--dl-space-space-threeunits);
  }
  .home-content20 {
    padding-left: var(--dl-space-space-oneandhalfunits);
    padding-right: var(--dl-space-space-oneandhalfunits);
  }
  .home-heading21 {
    font-size: 36px;
  }
  .home-comparision {
    gap: var(--dl-space-space-threeunits);
    padding-top: var(--dl-space-space-threeunits);
    padding-left: var(--dl-space-space-oneandhalfunits);
    padding-right: var(--dl-space-space-oneandhalfunits);
    padding-bottom: var(--dl-space-space-threeunits);
  }
  .home-header-container4 {
    gap: var(--dl-space-space-unit);
  }
  .home-header26 {
    gap: var(--dl-space-space-unit);
    align-items: center;
  }
  .home-heading22 {
    font-size: 40px;
  }
  .home-caption28 {
    font-size: 16px;
    line-height: 24px;
  }
  .home-text164 {
    font-size: 12px;
    line-height: 14px;
  }
  .home-text165 {
    font-size: 12px;
    line-height: 14px;
  }
  .home-text166 {
    font-size: 12px;
    line-height: 14px;
  }
  .home-text167 {
    font-size: 12px;
    line-height: 18px;
  }
  .home-text168 {
    font-size: 12px;
    line-height: 18px;
  }
  .home-text169 {
    font-size: 12px;
    line-height: 18px;
  }
  .home-text170 {
    line-height: 21px;
  }
  .home-text171 {
    font-size: 12px;
    line-height: 18px;
  }
  .home-text172 {
    line-height: 21px;
  }
  .home-text173 {
    line-height: 21px;
  }
  .home-text174 {
    font-size: 12px;
    line-height: 18px;
  }
  .home-text175 {
    line-height: 21px;
  }
  .home-text176 {
    font-size: 12px;
    line-height: 18px;
  }
  .home-text177 {
    font-size: 12px;
    line-height: 18px;
  }
  .home-text178 {
    line-height: 21px;
  }
  .home-data {
    padding-top: var(--dl-space-space-threeunits);
    padding-left: var(--dl-space-space-oneandhalfunits);
    padding-right: var(--dl-space-space-oneandhalfunits);
    padding-bottom: var(--dl-space-space-threeunits);
  }
  .home-heading23 {
    font-size: 36px;
  }
  .home-caption29 {
    font-size: 16px;
    line-height: 24px;
  }
  .home-image17 {
    width: 100%;
  }
  .home-image18 {
    width: 100%;
  }
  .home-customer {
    gap: var(--dl-space-space-threeunits);
    padding-top: var(--dl-space-space-threeunits);
    padding-left: var(--dl-space-space-oneandhalfunits);
    padding-right: var(--dl-space-space-oneandhalfunits);
    padding-bottom: var(--dl-space-space-threeunits);
  }
  .home-quote1 {
    gap: var(--dl-space-space-unit);
    width: 100%;
    height: auto;
    padding-right: 0px;
    padding-bottom: var(--dl-space-space-unit);
    border-right-width: 0px;
    border-bottom-width: 1px;
  }
  .home-quote2 {
    width: 90%;
    font-size: 14px;
    line-height: 21px;
  }
  .home-author3 {
    width: 100%;
  }
  .home-name3 {
    width: 90%;
    font-size: 14px;
    line-height: 21px;
  }
  .home-location1 {
    width: 90%;
    font-size: 14px;
    line-height: 21px;
  }
  .home-quote3 {
    gap: var(--dl-space-space-unit);
    width: 100%;
    height: auto;
    padding-right: 0px;
    padding-bottom: var(--dl-space-space-unit);
    border-right-width: 0px;
    border-bottom-width: 1px;
  }
  .home-quote4 {
    width: 90%;
    font-size: 14px;
    line-height: 21px;
  }
  .home-author4 {
    width: 100%;
  }
  .home-name4 {
    width: 90%;
    font-size: 14px;
    line-height: 21px;
  }
  .home-location2 {
    width: 90%;
    font-size: 14px;
    line-height: 21px;
  }
  .home-quote5 {
    gap: var(--dl-space-space-unit);
    width: 100%;
    height: auto;
    padding-right: 0px;
    padding-bottom: var(--dl-space-space-unit);
    border-right-width: 0px;
    border-bottom-width: 1px;
  }
  .home-quote6 {
    width: 90%;
    font-size: 14px;
    line-height: 21px;
  }
  .home-author5 {
    width: 100%;
  }
  .home-name5 {
    width: 90%;
    font-size: 14px;
    line-height: 21px;
  }
  .home-location3 {
    width: 90%;
    font-size: 14px;
    line-height: 21px;
  }
  .home-quote7 {
    gap: var(--dl-space-space-unit);
    width: 100%;
    height: auto;
    padding-right: 0px;
    padding-bottom: var(--dl-space-space-unit);
    border-right-width: 0px;
    border-bottom-width: 1px;
  }
  .home-quote8 {
    width: 90%;
    font-size: 14px;
    line-height: 21px;
  }
  .home-author6 {
    width: 100%;
  }
  .home-name6 {
    width: 90%;
    font-size: 14px;
    line-height: 21px;
  }
  .home-location4 {
    width: 90%;
    font-size: 14px;
    line-height: 21px;
  }
  .home-icon32 {
    width: 14px;
    height: 14px;
  }
  .home-icon34 {
    width: 14px;
    height: 14px;
  }
  .home-about-vhex {
    gap: var(--dl-space-space-threeunits);
    padding-top: var(--dl-space-space-threeunits);
    padding-left: var(--dl-space-space-oneandhalfunits);
    padding-right: var(--dl-space-space-oneandhalfunits);
    padding-bottom: var(--dl-space-space-threeunits);
  }
  .home-column1 {
    gap: var(--dl-space-space-oneandhalfunits);
  }
  .home-element5 {
    gap: var(--dl-space-space-halfunit);
    padding-top: 0px;
    padding-right: 00px;
    padding-bottom: var(--dl-space-space-oneandhalfunits);
    border-right-width: 0px;
  }
  .home-header33 {
    font-size: 16px;
    line-height: 20px;
  }
  .home-footer {
    padding-left: var(--dl-space-space-oneandhalfunits);
    padding-right: var(--dl-space-space-oneandhalfunits);
  }
  .home-links {
    gap: var(--dl-space-space-fiveunits);
    flex-direction: row;
  }
}
@media(max-width: 479px) {
  .home-hero-content {
    gap: var(--dl-space-space-threeunits);
  }
  .home-heading10 {
    font-size: 36px;
  }
  .home-heading11 {
    font-size: 36px;
  }
  .home-caption10 {
    font-size: 16px;
    line-height: 24px;
  }
  .home-button1 {
    text-align: center;
  }
  .home-heading13 {
    font-size: 36px;
    line-height: 42px;
  }
  .home-slide-titles {
    display: none;
  }
  .home-image14 {
    height: 400px;
  }
  .home-text133 {
    font-size: 12px;
    line-height: 18px;
  }
  .home-text134 {
    font-size: 18px;
  }
  .home-text136 {
    font-size: 18px;
  }
  .home-text138 {
    font-size: 18px;
  }
  .home-heading19 {
    font-size: 36px;
  }
  .home-heading20 {
    color: rgb(255, 255, 255);
  }
  .home-text146 {
    font-style: italic;
    font-family: Playfair Display;
    font-weight: 500;
  }
  .home-heading21 {
    color: rgb(255, 255, 255);
    font-style: normal;
    text-align: center;
    font-weight: 500;
  }
  .home-button4 {
    text-align: center;
  }
  .home-header26 {
    gap: 0px;
    flex-direction: column;
  }
  .home-heading22 {
    color: rgb(255, 255, 255);
    text-align: center;
  }
  .home-text161 {
    font-style: italic;
    font-family: Playfair Display;
    font-weight: 500;
  }
  .home-button5 {
    text-align: center;
  }
  .home-links {
    gap: var(--dl-space-space-threeunits);
    flex-direction: column;
  }
  .home-button6 {
    justify-content: center;
  }
  .home-bottom {
    gap: var(--dl-space-space-twounits);
    flex-direction: column;
    justify-content: center;
  }
}
</style>
